import { Component, OnDestroy, OnInit, ViewChild, AfterViewInit, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, ParamMap, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { debounce } from 'lodash-es';
import { MenuItem, MessageService } from 'primeng/api';
import { filter, firstValueFrom, forkJoin, fromEvent, Observable, Subject, Subscription, takeUntil, of } from 'rxjs';
import { EDITOR_MODE } from 'src/app/pages/code/code-editor/code-editor.model';
import {
  getAppsBasedOnSearch,
  getAppsForOrg,
  getGeneratedAppUrl,
  getMemApps,
  getSidBasedApps,
  setAllApps,
  setAppId,
  setAppMetaInfo,
  setApps,
  setFsLoginInitiated,
  setGenStatus,
  triggerPrototypingAppGeneration
} from 'src/app/STORE/actions/applifecycle.actions';
import { getUser, logoutUser, setUser } from 'src/app/STORE/actions/auth.actions';
import * as menuActions from 'src/app/STORE/actions/menu.actions';
import * as UsersAction from 'src/app/STORE/actions/users.actions';
import {
  allAppsList,
  appData,
  appDropList,
  genStatus,
  genStatus as genStatusSelector,
  genUrl,
  memAppList,
  publishLog,
  selectedAppData
} from 'src/app/STORE/selectors/applifecycle.selector';
import { userData } from 'src/app/STORE/selectors/auth.selector';
import { ApplifecycleEffects } from 'src/app/STORE/effects/applifecycle.effects';
import {
  getOrgDataForHeader,
  getOrglistforHeader,
  getSidBasedOrManagement,
  setOrgDelorDeactiveState
} from 'src/app/STORE/actions/orgmanagement.action';
import { orgDataForHeader, orglistForHeader, selectedOrgDeleted } from 'src/app/STORE/selectors/orgmanagement.selector';
import { getUsers, getUsersForSearch, setUsers } from 'src/app/STORE/actions/users.actions';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { DialogService } from 'primeng/dynamicdialog';
import { setMenuData } from 'src/app/STORE/actions/menu.actions';
import { menuData, toggleSideBar } from 'src/app/STORE/selectors/menu.selector';
import { curPage } from 'src/app/STORE/selectors/router.selector';
import { userAppData, usersSearchData } from 'src/app/STORE/selectors/users.selector';
import { ApiConstants } from 'src/app/base/api-constants';
import { GlobalConstants } from 'src/app/base/global.constants';
import { environment } from 'src/environments/environment';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { FsBaseService } from 'src/app/services/fs-base.service';
import { getPendingService } from 'src/app/services/pendingHttpServices.service';
import { ApplicationTypes, OrgRole, PublishTypes } from 'src/app/services/util.enum';
import { UtilService } from 'src/app/services/util.service';
import { AppLoaderService } from 'src/app/services/app-loader.service';
import { TranslateService } from '@ngx-translate/core';
import MetaInfoStaticData from 'src/assets/configData/appMetaStaticData.json';
import { getAppSettings, getMemberApps } from 'src/app/STORE/actions/technologystack.actions';
import { appSettingsData, memberApps } from 'src/app/STORE/selectors/technologystack.selector';
import { DeltaSqlGenerationComponent } from '../delta-sql-generation/delta-sql-generation.component';
import { HeaderService } from 'src/app/services/header.service';
import { PreValidationTblViewComponent } from '@components/pre-validation-tbl-view/pre-validation-tbl-view.component';
import { RtIconBillingHomeComponent } from '@rt-icons/rt-icon-billing-home/rt-icon-billing-home.component';
import { RtIconCloudComponent } from '@rt-icons/rt-icon-cloud/rt-icon-cloud.component';
import { MergeStatusService, MergeStatusInfo } from 'src/app/services/merge-status.service';
import { RepoManagementService } from 'src/app/pages/settings/branch-management/repo-management/repo-management.service';
import { AppStateService } from 'src/app/services/app-state.service';
import { SESSION_MERGE_STATUS } from 'src/app/base/companion-constants';
import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';

@AutoUnsubscribe({ arrayName: 'subscriptions' })
@Component({
  selector: 'vb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [DialogService],
  standalone: false //NOSONAR
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  headerService = inject(HeaderService);
  private appStateService = inject(AppStateService);
  private document = inject(DOCUMENT);
  private store = inject(Store);
  private router = inject(Router);
  private appGlobalService = inject(AppGlobalService);
  private titleService = inject(Title);
  messageService = inject(MessageService);
  private utilService = inject(UtilService);
  private activatedRoute = inject(ActivatedRoute);
  private readonly acRoute = inject(ActivatedRoute);
  private getPendingService = inject(getPendingService);
  private confirmationDialogService = inject(ConfirmationDialogService);
  private baseService = inject(HttpBaseService);
  private fsBaseService = inject(FsBaseService);
  private loader = inject(AppLoaderService);
  private dialogService = inject(DialogService);
  private angularFireAuth = inject(AngularFireAuth);
  private translate = inject(TranslateService);
  private readonly fsService = inject(FsBaseService);

  confirmPublish = false;
  showLogPopUp = false;
  showWarnAppPop = false;
  raiModeEnabledForUser = false;
  raiModeEnabledForApp = false;
  action = '';
  actionHeader = '';
  godeGenerationAction = '';
  value = 0;
  showNotification = false;
  compilationFailed: boolean | null = false;
  showProgressBar = false;
  silentProgress = false;
  showEyeIcon = false;
  nosqlRappitLink = GlobalConstants.rappitNosqlLink;
  nosqlRapLinkName = GlobalConstants.rappitNosqlLinkName;
  successStatus = this.utilService.successStatus;
  targetBranchCreationInProgress = false;

  config = {
    flags: {
      isApp_MergeStatus_InProgress: false
    }
  };

  readonly SESSION_MERGE_STATUS = SESSION_MERGE_STATUS;

  isChatCollapsed = false;
  activeArtifactTab = 'blueprint';
  isSessionsPanelOpen = false;
  isNewSessionActive = false;

  private appIdForsessionList: any;
  private chatSessionList$: Subscription;

  updateActiveArtifactTabFromUrl(url: string) {
    if (url.includes('/prototyping/preview')) {
      this.activeArtifactTab = 'preview';
    } else if (url.includes('/code/editor') || url.includes('/code/preview') || url.includes('/code')) {
      this.activeArtifactTab = 'code';
    } else if (url.includes('/blueprint')) {
      this.activeArtifactTab = 'blueprint';
    } else if (url.includes('/app-dashboards/test-management')) {
      this.activeArtifactTab = 'test';
    } else if (url.includes('/operate/')) {
      this.activeArtifactTab = 'operate';
    } else {
      this.activeArtifactTab = 'build';
    }
    this.headerService.activeArtifactTab$.next(this.activeArtifactTab);

    if (this.activeArtifactTab === 'code' || this.activeArtifactTab === 'preview') {
      setTimeout(() => {
        this.headerService.setChatCollapsedState(true);
      }, 0);
    }
  }

  switchArtifactTab(tabValue: string) {
    this.activeArtifactTab = tabValue;
    this.headerService.activeArtifactTab$.next(this.activeArtifactTab);

    const appId = this.appGlobalService.get('appId');
    const orgId = this.appGlobalService.get('orgId');

    if (tabValue === 'code' || tabValue === 'preview') {
      this.headerService.setChatCollapsedState(true);
    }

    if (tabValue === 'code') {
      this.router.navigate(['/home', orgId, appId, 'code', 'editor'], {
        relativeTo: this.activatedRoute,
        queryParams: { editorType: EDITOR_MODE.SIMPLE },
        queryParamsHandling: 'merge'
      });
    } else if (tabValue === 'preview') {
      this.router.navigate(['/home', orgId, appId, 'prototyping', 'preview'], {
        relativeTo: this.activatedRoute,
        queryParamsHandling: 'merge'
      });
    } else if (tabValue === 'blueprint') {
      this.router.navigate(['/home', orgId, appId, 'blueprint', 'project-charter'], {
        relativeTo: this.activatedRoute,
        queryParamsHandling: 'merge'
      });
    } else if (tabValue === 'test') {
      this.router.navigate(['/home', orgId, appId, 'app-dashboards', 'test-management'], {
        relativeTo: this.activatedRoute,
        queryParamsHandling: 'merge'
      });
    } else if (tabValue === 'operate') {
      this.router.navigate(['/home', orgId, appId, 'operate', 'overview'], {
        relativeTo: this.activatedRoute,
        queryParamsHandling: 'merge'
      });
    } else if (tabValue === 'build') {
      this.router.navigate(['/home', orgId, appId, 'build', 'overview'], {
        relativeTo: this.activatedRoute,
        queryParamsHandling: 'merge'
      });
    }
  }

  navigateToAppSettings(): void {
    const appId = this.appGlobalService.get('appId');
    const orgId = this.appGlobalService.get('orgId');
    this.router.navigate(['/home', orgId, appId, 'technicaldesign', 'appsettings'], {
      relativeTo: this.activatedRoute,
      queryParamsHandling: 'merge'
    });
  }

  compilationStatus = [
    'GENERATION_INPROGRESS',
    'PROTOTYPE_GENERATION_INPROGRESS',
    'PROTOTYPE_COMPILATION_IN_PROGRESS',
    'AUTOMATION_BEGENERATION_INPROGRESS',
    'BE_GENERATION_INPROGRESS',
    'BACKEND_GENERATION_INPROGRESS'
  ];

  publishPrototypeStatus = {
    PROJECTMETAINFO_READ_INPROGRESS: 10,
    VALIDATION_STARTED: 20,
    VALIDATION_COMPLETED: 25,
    SKELETON_COPY_STARTED: 30,
    EVENTMETAINFO_CREATION_INPROGRESS: 30,
    GENERATION_INPROGRESS: 80,
    PROTOTYPE_COMPILATION_IN_PROGRESS: 80,
    PUBLISH_COMPLETED: 100
  };

  gitCodePullStatus = {
    PROJECTMETAINFO_READ_INPROGRESS: 10,
    VALIDATION_STARTED: 20,
    VALIDATION_COMPLETED: 25,
    SKELETON_COPY_STARTED: 30,
    EVENTMETAINFO_CREATION_INPROGRESS: 30,
    PULL_IN_PROGRESS: 30,
    GENERATION_INPROGRESS: 80,
    PROTOTYPE_COMPILATION_IN_PROGRESS: 80,
    PUBLISH_COMPLETED: 100
  };

  firstCodePushStatus = {
    PROJECTMETAINFO_READ_INPROGRESS: 10,
    VALIDATION_STARTED: 20,
    VALIDATION_COMPLETED: 25,
    SKELETON_COPY_STARTED: 30,
    EVENTMETAINFO_CREATION_INPROGRESS: 30,
    GENERATION_INPROGRESS: 80,
    PROTOTYPE_COMPILATION_IN_PROGRESS: 80,
    PUSH_INPROGRESS: 80,
    PUBLISH_COMPLETED: 100
  };

  gitCodePushStatus = {
    PROJECTMETAINFO_READ_INPROGRESS: 10,
    VALIDATION_STARTED: 15,
    VALIDATION_COMPLETED: 20,
    SKELETON_COPY_STARTED: 25,
    EVENTMETAINFO_CREATION_INPROGRESS: 30,
    PULL_IN_PROGRESS: 30,
    GENERATION_INPROGRESS: 80,
    PROTOTYPE_COMPILATION_IN_PROGRESS: 80,
    PUSH_INPROGRESS: 90,
    PUBLISH_COMPLETED: 100
  };

  private readonly mergeStatusService = inject(MergeStatusService);
  private readonly repoService = inject(RepoManagementService);
  blockedDocument = false;
  isMenuCollapsed = false; // Default-value for sideNav of Detail-app
  userMenuItems: MenuItem[] = [];
  curPage: Observable<any> = this.store.select(curPage);
  mergeStatusInfo: MergeStatusInfo | null = null;

  get isTag(): boolean {
    return this.appGlobalService.get('appRefType') === 'TAG';
  }

  get productVersion(): string {
    // Get library version from app settings dependencies array (e.g., @rappit/rd-ng-lib@26.5.1-6)
    // Keeps version suffix for UI Libraries
    const technologySettings = this.appGlobalService.get('technologySettings') as {
      dependencies?: { default?: string[] };
    };
    if (technologySettings?.dependencies?.default && Array.isArray(technologySettings.dependencies.default)) {
      const libEntry = technologySettings.dependencies.default.find(
        (dep: string) => typeof dep === 'string' && dep.startsWith('@rappit/rd-ng-lib@')
      );
      if (libEntry) {
        // Extract version from "@rappit/rd-ng-lib@26.5.1-6" -> "26.5.1-6"
        return libEntry.split('@rappit/rd-ng-lib@')[1] || '';
      }
    }
    // Fallback to app version if library version not available
    return String(this.appGlobalService.get('appVersion') || '');
  }

  get beLibraryVersion(): string {
    // Get library version without suffix for Backend Libraries (e.g., 26.5.1)
    const fullVersion = this.productVersion;
    // Strip suffix after dash to get semantic version (26.5.1-6 -> 26.5.1)
    return fullVersion.split('-')[0];
  }

  private mergeStatusSubscription: Subscription | null = null;
  generationStatus$: Observable<any> = this.store.select(genStatus);
  loggedInUser = '';
  getButtonState = 'GEN_COMPLETED';
  avatarImage: any = null;
  progressBarMsg: any;
  cloudBuildLog: any;
  apps: any[] = [];
  showPublish = false;
  test = 40;
  orgVal: any;
  gitErrorCodes = [
    'GIT_PULL_PERMISSION_EXCEPTION ',
    'GIT_PUSH_PERMISSION_EXCEPTION',
    'GITLAB_GROUP_PERMISSION_EXCEPTION',
    'GITLAB_PROJECT_PERMISSION_EXCEPTION',
    'GITLAB_ENVIRIONEMT_VARIABLE_PERMISSION_EXCEPTION',
    'GITHUB_REPO_CREATION_PERMISSION_EXCEPTION',
    'GITHUB_REPO_DELETION_PERMISSION_EXCEPTION'
  ];
  headerMsg: any;
  cloudBuildId: any;
  routerOrgId: any;
  applicationType: any;
  bnmVersion = GlobalConstants.bnmVersion;
  showBranchDropdown = false;
  isCommitInProgress = false;
  codeCommitStatus = '';
  routerAppId: any;
  appPage = false;
  appDataWithId: any;
  genBoolean = false;
  sharedDbId: any;
  suiteId: any;
  selectedApp: any = {};
  previousData: any;
  buttonGroups: MenuItem[];
  previewMsg: any;
  headerEmpMsg = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  text: any;
  results: string[];
  logsArray: any[] = [];
  userAppData: any[] = [];
  searchText = '';
  searchTextOrg: any;
  techStackData: any;
  disablePreview: boolean;
  genAppId: any = '';
  autocompleteLoader = false;
  filteredAppData = [];
  private suiteNameCache = new Map<string, string>();
  @ViewChild('dropdownEle') dropdownEle;
  @ViewChild('dropdownEle1') dropdownEle1;
  @ViewChild('userMenu') userMenu: any;
  user: any;
  userRole: any;
  role: any;
  subscriptions: Subscription[] = [];
  genStsSubscription: Subscription;
  menuJSON: any = [];
  genAppUrl = false;
  spinner = true;
  appData: any;
  publishMessage = '';
  prototypingAppUrl: any;
  disallowPrototype = false;
  disallowGit = false;
  selectedOrg: any = {};
  headerLoader = false;
  orgs: any = [];
  userOrgs: any = [];
  attachAppInfoListnerSubscription: any = [];
  attachGenerationStatusListnerSubscription: any = [];
  blockedMessage: string;
  notifyingUser: boolean;
  allowPublishWarn = true;
  allowGitPushWarn = false;
  get hasSessionId(): boolean {
    return !!this.appGlobalService.get('sessionId');
  }

  showPublishStatus = false;
  showPrototypePopup = false;
  isPrototypePublished = false;
  generationApiStatus: any = null;
  generationApiError: any = null;
  lastPublishData: any = {};
  lastCompletedPublishData: any = {};
  generationLogs: any[] = [];
  uiLibPushStatus = {
    UI_LIBRARIES_PUSH_IN_PROGRESS: 50,
    UI_LIBRARIES_PUSH_COMPLETED: 100
  };
  beLibPushStatus = {
    BE_LIBRARIES_PUSH_IN_PROGRESS: 50,
    BE_LIBRARIES_PUSH_COMPLETED: 100
  };
  failedStatus = this.utilService.failedStatus;
  trigerMaintenance = false;
  maintenanceLabel = 'START_MAINTENANCE';
  menuData = [];
  blockerType = '';
  previousGenerationStatus = '';
  preValPopupExist = false;
  appId: any;
  generationLogAppId: any;
  maintenanceModeSub$: Subscription = new Subscription();
  branchingStatusByAppSub$: Subscription | null = null;
  branchingStatusByTargetSub$: Subscription | null = null;
  orgData: any;
  maintenance: any;
  appcopy: any;
  referenceMaintenance = false;
  appcopyModifiedBy: any;
  appcopyModifiedDate: any;
  selectedAppDispName: any = 'Select an app';
  isSearchquery: boolean;
  offlineEvent: Observable<Event>;
  onlineEvent: Observable<Event>;
  currentUrl: string;
  appSpecificMaintenance: boolean;
  currentPage = '';
  blockerData: any = {};
  codeGenerationLogSub$: Subscription;
  lastUsedAppIdForFsSignIn: any;
  actionMessage: any;
  isBetaAccessEnabled = false;
  isBetaAccessPrivilegeConsumable = false;
  isBetaAccessPrivilegeConsumableForApp = false;
  previousBetaAccess: boolean | null = null;
  private userDocListener: Subscription | null = null;
  private initialUserSnapshot: any = null;
  private sharedAccessListener: Subscription | null = null;
  private allAppsListener: Subscription | null = null;
  private initialSharedWith: Record<string, string> | null = null;
  orgListForHeader$: any;
  private branchDeletionHandled = false;
  currentBranchStatus: string = '';
  isCloneInProgress = false;
  private readonly cloneStatusMap: Map<string, string> = new Map();
  private readonly BranchingStatusMap: Map<string, string> = new Map();

  constructor() {
    this.angularFireAuth.setPersistence('none').catch((error) => console.error(error));
  }

  checkboxChange(event) {
    event.originalEvent.stopPropagation();
  }

  viewNotification() {
    if (!this.preValPopupExist) {
      this.preValPopupExist = true;
      this.baseService.get({ ...ApiConstants.getPrevalidationsByAppId, ...{ showSpinner: true } }).subscribe({
        next: (response: any) => {
          this.showPublishStatus = false;
          this.preValPopupExist = false;
          if (response.preValicationList) {
            this.dialogService.open(PreValidationTblViewComponent, {
              showHeader: false,
              styleClass: 'reference-tree',
              modal: true,
              data: {
                prevalidationList: response
              }
            });
          }
        },
        error: () => {
          this.loader.hide();
          this.preValPopupExist = false;
        }
      });
    }
  }

  appCreation() {
    const params = {
      appId: this.appGlobalService.get('appId')
    };
    this.store.dispatch(triggerPrototypingAppGeneration({ genAppApi: ApiConstants.createApp, genParams: params }));
  }

  logSubscription() {
    const promise = new Promise<void>((resolve, reject) => {
      const ref$ = this.baseService
        .get({ ...ApiConstants.getCloudLogs, ...{ showSpinner: true } }, { cloudBuildId: this.cloudBuildId }, 'text')
        .subscribe({
          next: (res: any) => {
            resolve(res);
          },
          error: (err: any) => {
            reject(err);
          }
        });
    });
    return promise;
  }

  getCloudBuildLog() {
    this.logSubscription().then((value: any) => {
      this.showPublishStatus = false;
      this.showLogPopUp = true;
      this.cloudBuildLog = value;
      this.logsArray = value.split('\n');
    });
    this.messageService.clear();
  }

  closePopup() {
    this.showPublishStatus = false;
    this.showLogPopUp = false;
  }

  getGenerationStatus(action) {
    if (
      this.generationApiStatus !== 'error' &&
      this.generationApiStatus !== 'apiError' &&
      this.generationApiStatus !== 'anotherGeneration'
    ) {
      this.showPublishStatus = false;
      this.showProgressBar = !this.silentProgress;
      this.headerService.updateProgress(true, 0);
      this.getCodeGenerationStatus();
      this.generationStatusSub(this.appId, action);
    }
  }

  debouncegeneration = debounce(this.getGenerationStatus.bind(this), 1000);

  storePublishAction(action) {
    this.godeGenerationAction = action;
    if (action === PublishTypes.PROTOTYPE) {
      this.action = this.translate.instant('PUBLISH_PROTOTYPE_CODE');
      this.actionHeader = this.translate.instant('PUBLISH_PROTOTYPE');
      this.actionMessage = this.translate.instant('PUBLISH_PROTOTYPE_MESSAGE');
    } else if (action === PublishTypes.PUSH) {
      this.action = this.translate.instant('GIT_PUSH');
      this.actionHeader = this.translate.instant('GIT_PUSH');
      this.actionMessage = this.translate.instant('GIT_PUSH_MESSAGE');
    } else if (action === PublishTypes.PUSH_UI_LIBRARIES) {
      this.action = this.translate.instant('UI_LIB_GIT_PUSH');
      this.actionHeader = this.translate.instant('PUBLISH_UI_LIB_GIT');
      this.actionMessage = this.translate.instant('PUBLISH_UI_LIB_GIT_MESSAGE');
    } else if (action === PublishTypes.PUSH_BE_LIBRARIES) {
      this.action = this.translate.instant('BE_LIB_GIT_PUSH');
      this.actionHeader = this.translate.instant('PUBLISH_BE_LIB_GIT');
      this.actionMessage = this.translate.instant('PUBLISH_BE_LIB_GIT_MESSAGE');
    } else {
      this.action = this.translate.instant('GIT_PULL');
      this.actionHeader = this.translate.instant('GIT_PULL');
      this.actionMessage = this.translate.instant('GIT_PULL_MESSAGE');
    }
  }

  showConfirmPublish(action) {
    if (this.isCloneInProgress) {
      return;
    }
    this.clearData();
    this.confirmPublish = true;
    this.storePublishAction(action);
  }

  closeConfirm() {
    this.confirmPublish = false;
  }

  clearData() {
    this.godeGenerationAction = '';
    this.action = '';
    this.actionHeader = '';
    this.actionMessage = '';
  }

  codeGeneration() {
    this.confirmPublish = false;
    this.generationApiStatus = null;
    this.genBoolean = false;
    // Clear stale publish data before showing progress bar to prevent
    // momentarily displaying the previous publish type's in-progress state
    this.lastPublishData = {};
    this.showProgressBar = !this.silentProgress;
    this.headerService.updateProgress(true, 0);
    const ignoreWarnings = this.allowPublishWarn;
    this.value = 0;
    this.showNotification = false;
    this.compilationFailed = null;
    this.store.dispatch(setGenStatus({ genStatus: null }));
    const appId = this.appGlobalService.get('appId');
    const isUiLibPush = this.godeGenerationAction === PublishTypes.PUSH_UI_LIBRARIES;
    const isBeLibPush = this.godeGenerationAction === PublishTypes.PUSH_BE_LIBRARIES;
    const isLibPush = isUiLibPush || isBeLibPush;
    const payload = {
      appId: appId,
      generationTypes: this.godeGenerationAction,
      ignoreWarnings: ignoreWarnings,
    };
    const apiConstant = isUiLibPush
      ? ApiConstants.pushUiLibraries
      : isBeLibPush
        ? ApiConstants.pushBeLibraries
        : ApiConstants.codeGeneration;

    // should append map here
    // immediate 200 of call, was resetting flag.. currently, there is no RESET unless service fails
    // FOR DEMO-day purpose
    this.appGlobalService.updateRecentApp({
      appId: appId,
      action: 'publish-submitted'
    });

    const codeGenSub = this.baseService.post({ ...apiConstant, ...{ showErrorMsg: false } }, payload).subscribe(
      (res: any) => {
        if (appId === this.appId) {
          if (this.value === 100) {
            this.generationApiStatus = 'success';
            this.showPublishStatus = true;
            this.showProgressBar = false;
            this.headerService.updateProgress(false, 100);
            // Only show eye icon for non-library-push scenarios
            if (!isLibPush) {
              this.showEyeIcon = true;
              this.isPrototypePublished = true;
            }
          }
          if (res?.status === 'warnings') {
            this.showNotification = true;
          }
        }
      },
      (err) => {
        if (appId === this.appId) {
          const error = err.error;
          this.showPublishStatus = true;
          // Only show eye icon for non-library-push scenarios
          if (!isLibPush) {
            this.showEyeIcon = true;
            this.isPrototypePublished = true;
          }
          this.showProgressBar = false;
          this.headerService.updateProgress(false, this.value);
          this.store.dispatch(setGenStatus({ genStatus: null }));
          clearTimeout(ApplifecycleEffects.genStatusTimeout);
          if (error?.ERROR_CODE === 'PREVALIDATION_FAILED_WITH_ERROR_MESSGAES') {
            this.generationApiStatus = 'error';
            this.showNotification = true;
          } else if (error?.ERROR_CODE === 'TASK_EXECUTION_IN_PROGRESS') {
            this.generationApiStatus = 'taskExecutionInProgress';
          } else {
            if (error?.MESSAGE) {
              this.generationApiError = error?.MESSAGE;
            } else if (error?.MESSAGE === 'ANOTHER_GENERATION_IN_PROGRESS') {
              this.generationApiError = '';
            } else {
              if (isUiLibPush) {
                this.generationApiError = this.translate.instant('UI_LIB_GENERATION_FAILED');
              } else if (isBeLibPush) {
                this.generationApiError = this.translate.instant('BE_LIB_GENERATION_FAILED');
              } else {
                this.generationApiError = this.translate.instant('GENERATION_FAILED');
              }
            }
            if (error?.MESSAGE === 'ANOTHER_GENERATION_IN_PROGRESS') {
              this.generationApiStatus = 'anotherGeneration';
            } else {
              this.generationApiStatus = 'apiError';
            }
          }

          // just to reset flag, for overcoming map-lock
          this.appGlobalService.updateRecentApp({
            appId: appId,
            action: 'publish-completed'
          });
        }
      }
    );
    this.subscriptions.push(codeGenSub);
    // Enable Firestore listeners for ALL publish types including library pushes
    this.debouncegeneration(this.godeGenerationAction);
  }

  getPublishStatus(data: any) {
    const metaInfo = this.appGlobalService.get('appmetaInfo');
    if (data.modifiedDate?.toDate) {
      data.modifiedDate = data.modifiedDate.toDate();
    }
    if (data.gitPushTime?.toDate) {
      data.gitPushTime = data.gitPushTime.toDate();
    }
    if (metaInfo[data.createdBy]) {
      data.name = metaInfo[data.createdBy];
      data.avatarImage = this.getAvatar(metaInfo[data.createdBy]);
    }
    this.lastPublishData = {};
    switch (data.generationType) {
      case PublishTypes.PROTOTYPE:
        this.lastPublishData = { prototype: data };
        break;
      case PublishTypes.PULL:
        this.lastPublishData = { pull: data };
        break;
      case PublishTypes.PUSH:
        this.lastPublishData = { push: data, pull: data, prototype: data };
        break;
      case PublishTypes.PUSH_UI_LIBRARIES:
        this.lastPublishData = { uiLibPush: data };
        break;
      case PublishTypes.PUSH_BE_LIBRARIES:
        this.lastPublishData = { beLibPush: data };
        break;
    }
  }

  updateLastCompletedPublishData() {
    const completedLog = this.generationLogs.find((log) => log.generationStatus === 'PUBLISH_COMPLETED');
    if (!completedLog) {
      return;
    }
    const data = { ...completedLog };
    const metaInfo = this.appGlobalService.get('appmetaInfo');
    if (data.modifiedDate?.toDate) {
      data.modifiedDate = data.modifiedDate.toDate();
    }
    if (data.gitPushTime?.toDate) {
      data.gitPushTime = data.gitPushTime.toDate();
    }
    if (metaInfo[data.createdBy]) {
      data.name = metaInfo[data.createdBy];
      data.avatarImage = this.getAvatar(metaInfo[data.createdBy]);
    }
    this.lastCompletedPublishData = {};
    const prototypeLog = this.generationLogs.find(
      (log) => log.generationStatus === 'PUBLISH_COMPLETED' && log.generationType === PublishTypes.PROTOTYPE
    );
    const pullLog = this.generationLogs.find(
      (log) => log.generationStatus === 'PUBLISH_COMPLETED' && log.generationType === PublishTypes.PULL
    );
    const pushLog = this.generationLogs.find(
      (log) => log.generationStatus === 'PUBLISH_COMPLETED' && log.generationType === PublishTypes.PUSH
    );
    const uiLibLog = this.generationLogs.find(
      (log) => log.generationStatus === 'UI_LIBRARIES_PUSH_COMPLETED' && log.generationType === PublishTypes.PUSH_UI_LIBRARIES
    );
    const beLibLog = this.generationLogs.find(
      (log) => log.generationStatus === 'BE_LIBRARIES_PUSH_COMPLETED' && log.generationType === PublishTypes.PUSH_BE_LIBRARIES
    );

    const logs = [
      { type: 'prototype', log: prototypeLog },
      { type: 'pull', log: pullLog },
      { type: 'push', log: pushLog },
      { type: 'uiLibPush', log: uiLibLog },
      { type: 'beLibPush', log: beLibLog }
    ];

    logs.forEach((item) => {
      if (item.log) {
        const data = { ...item.log };
        if (data.modifiedDate?.toDate) {
          data.modifiedDate = data.modifiedDate.toDate();
        }
        if (data.gitPushTime?.toDate) {
          data.gitPushTime = data.gitPushTime.toDate();
        }
        if (metaInfo[data.createdBy]) {
          data.name = metaInfo[data.createdBy];
          data.avatarImage = this.getAvatar(metaInfo[data.createdBy]);
        }
        this.lastCompletedPublishData[item.type] = data;

        // Maintain the cross-type mapping for PUSH/PROTOTYPE as per original logic
        if (item.type === 'push') {
          if (!this.lastCompletedPublishData.pull) {
            this.lastCompletedPublishData.pull = data;
          }
          if (!this.lastCompletedPublishData.prototype) {
            this.lastCompletedPublishData.prototype = data;
          }
        }
      }
    });
  }

  handleHamburgerClick() {
    this.isMenuCollapsed = !this.isMenuCollapsed;

    this.dispatchMenuCollapsedEvent();

    const appIdInURL = this.router.url.split('/')[3];

    if (appIdInURL === 'appId') {
      const orgId = this.appGlobalService.get('orgId');
      this.router
        .navigate(['/home', orgId, 'appId', 'settings', 'appmanagement'])
        .catch((error) => console.error(error));
    }
  }

  triggerLogout() {
    // Cleanup user document listener
    this.cleanupUserDocListener();
    // Cleanup shared access listener
    this.cleanupSharedAccessListener();
    this.unSubscribeListener();

    this.cleanupListener_AIChatSession();

    this.mergeStatusService.unsubscribeFromMergeStatus();
    if (this.mergeStatusSubscription) {
      this.mergeStatusSubscription.unsubscribe();
      this.mergeStatusSubscription = null;
    }
    if (this.maintenanceModeSub$) {
      this.maintenanceModeSub$.unsubscribe();
    }
    if (this.codeGenerationLogSub$) {
      this.codeGenerationLogSub$.unsubscribe();
    }
    if (this.genStsSubscription) {
      this.genStsSubscription.unsubscribe();
    }
    this.angularFireAuth.signOut().catch((error) => console.error(error));
    this.appGlobalService.write(GlobalConstants.tenantId, null);
    localStorage.removeItem('allUsers');
    this.store.dispatch(logoutUser());
  }

  getRandomColor(name, s = 50, l = 50) {
    if (!name) {
      return false;
    }
    const firstAlphabet = name?.charAt(0).toLowerCase();

    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }

    const h = hash % 360;
    const newColour = `hsl(${h}, ${s}%, ${l}%)`;

    return {
      color: newColour,
      character: firstAlphabet.toUpperCase()
    };
  }

  createNewSession(): void {
    this.headerService.triggerCreateNewSession();
  }

  openSessionsPanel(): void {
    this.headerService.triggerOpenSessions();
  }

  toggleChat(): void {
    this.headerService.triggerToggleChat();
  }

  cleanupUserDocListener() {
    if (this.userDocListener) {
      this.userDocListener.unsubscribe();
      this.userDocListener = null;
      this.initialUserSnapshot = null;
    }
  }

  cleanupSharedAccessListener() {
    if (this.sharedAccessListener) {
      this.sharedAccessListener.unsubscribe();
      this.sharedAccessListener = null;
      this.initialSharedWith = null;
    }
    if (this.allAppsListener) {
      this.allAppsListener.unsubscribe();
      this.allAppsListener = null;
    }

    this.appStateService.clearDataSource({
      name: 'App'
    });
  }

  ngOnDestroy(): void {
    // Cancel the pending debounced API call to prevent a memory leak
    // or an API call firing right after the component is destroyed.
    if (this.debounceGetAppsForOrganization) {
      this.debounceGetAppsForOrganization.cancel();
    }
    if (this.debounceGetDefaultBranches) {
      this.debounceGetDefaultBranches.cancel();
    }

    $('body').removeClass('screens-overlay');
    this.store.dispatch(setFsLoginInitiated({ loggedIn: false }));
    this.headerService.completeAppMaintenanceStatusSubject();
    this.unSubscribeListener();

    this.isMenuCollapsed = false;
    if (this.mergeStatusSubscription) {
      this.mergeStatusSubscription.unsubscribe();
    }
    // Cleanup user document listener
    this.cleanupUserDocListener();
    // Cleanup shared access listener
    this.cleanupSharedAccessListener();

    this.cleanupListener_AIChatSession();
  }

  unSubscribeListener() {
    if (this.attachAppInfoListnerSubscription) {
      this.attachAppInfoListnerSubscription.forEach((sub) => {
        if (typeof sub.unsubscribe === 'function') {
          sub.unsubscribe();
        }
      });
    }

    if (this.attachGenerationStatusListnerSubscription) {
      this.attachGenerationStatusListnerSubscription.forEach((sub) => {
        if (typeof sub.unsubscribe === 'function') {
          sub.unsubscribe();
        }
      });
    }
  }

  /**
   * Get the branch role (source or target) for the current app in the merge
   */
  getMergeBranchRole(): string {
    if (!this.mergeStatusInfo) {
      return '';
    }
    const currentAppId = this.appGlobalService.get('appId');
    const isSourceBranch = currentAppId === this.mergeStatusInfo.sourceBranchId;
    return isSourceBranch ? this.translate.instant('SOURCE_BRANCH') : this.translate.instant('TARGET_BRANCH');
  }

  /**
   * Check if the current user is the one who initiated the merge
   */
  isCurrentUserMergeInitiator(): boolean {
    if (!this.mergeStatusInfo) {
      return false;
    }
    const currentUserEmail = this.appGlobalService.get('userEmail');
    const currentUserId = this.appGlobalService.get('user')?.sid;
    return (
      this.mergeStatusInfo.initiatedById === currentUserEmail || this.mergeStatusInfo.initiatedById === currentUserId
    );
  }

  /**
   * Show merge details popup with cancel option (only during review phase)
   */
  showMergeDetailsPopup(): void {
    if (!this.mergeStatusInfo) {
      return;
    }

    // Hide Cancel Merge button during all active merge statuses (after Confirm Merge is clicked)
    const activeMergeStatuses = [
      'MERGE_PROCESS_IN_PROGRESS',
      'MERGE_VALIDATION_IN_PROGRESS',
      'MERGE_TAG_CREATION_STARTED',
      'PUBLISH_PROCESS_STARTED'
    ];
    const isMergeProcessing = activeMergeStatuses.includes(this.mergeStatusInfo.status || '');

    this.confirmationDialogService.confirm({
      key: 'mergeDetailsPopup',
      message: '',
      header: this.translate.instant('MERGE_IN_PROGRESS'),
      acceptLabel: isMergeProcessing ? '' : 'Cancel Merge',
      rejectLabel: 'Close',
      acceptButtonStyleClass: isMergeProcessing ? 'hidden-button' : 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary p-button-outlined',
      acceptVisible: !isMergeProcessing,
      accept: () => {
        if (!isMergeProcessing) {
          this.cancelMergeProcess();
        }
      }
    });
  }

  /**
   * Cancel the ongoing merge process
   */
  cancelMergeProcess(): void {
    if (!this.mergeStatusInfo?.mergeId) {
      return;
    }

    // Show confirmation popup before canceling
    this.confirmationDialogService.confirm({
      key: 'cancelMergeConfirmation',
      message: this.translate.instant('CANCEL_MERGE_CONFIRMATION'),
      header: this.translate.instant('CONFIRM_CANCEL'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translate.instant('YES_CANCEL_MERGE'),
      rejectLabel: this.translate.instant('NO'),
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => {
        this.executeMergeCancel();
      }
    });
  }

  /**
   * Execute the merge cancellation API call
   */
  private executeMergeCancel(): void {
    if (!this.mergeStatusInfo?.mergeId) {
      return;
    }

    // Mark as cancelled by user to prevent popup from showing
    this.mergeStatusService.markAsCancelledByUser();

    this.loader.show();
    this.repoService.cancelMergeHistoryTracker(this.mergeStatusInfo.mergeId).subscribe({
      next: () => {
        this.loader.hide();
        this.utilService.showSuccess(
          this.translate.instant('SUCCESS'),
          this.translate.instant('MERGE_CANCELLED_SUCCESS')
        );
        // Clear the merge status - route reload will be handled by merge-status service
        // when Firestore listener detects the cancellation
        this.mergeStatusInfo = null;
      },
      error: (error) => {
        this.loader.hide();
        this.utilService.showError(this.translate.instant('ERROR'), this.translate.instant('MERGE_CANCEL_FAILED'));
        console.error('Error cancelling merge:', error);
      }
    });
  }

  getAvatar(name: string) {
    return this.getRandomColor(name);
  }

  getCurrentUser() {
    this.store.dispatch(getUser({ authApiConstants: ApiConstants.authenticateUser }));
    const userSub = this.store
      .select(userData)
      .pipe(
        filter((userInfo: any) => !!userInfo) // Only proceed if userInfo exists
      )
      .subscribe((userInfo: any) => {
        this.loggedInUser = `${userInfo.firstName.charAt(0).toUpperCase() + userInfo.firstName.slice(1)} ${userInfo.lastName.charAt(0).toUpperCase() + userInfo.lastName.slice(1)}`;
        this.avatarImage = this.getAvatar(userInfo.firstName);

        this.raiModeEnabledForApp = this.appGlobalService.isRaiModeEnabledForApp();

        this.raiModeEnabledForUser = this.appGlobalService.getBoolean('raiModeEnabledForUser');
        this.isBetaAccessEnabled = this.appGlobalService.getBoolean('isBetaAccessEnabled');

        this.isBetaAccessPrivilegeConsumable = this.appGlobalService.isBetaAccessPrivilegeConsumable();
        this.isBetaAccessPrivilegeConsumableForApp = this.appGlobalService.isBetaAccessPrivilegeConsumableForApp();

        this.user = userInfo;

        this.getUserRole();

        if (this.routerAppId !== 'appId' && this.previousBetaAccess !== this.isBetaAccessPrivilegeConsumable) {
          this.previousBetaAccess = this.isBetaAccessPrivilegeConsumable;
          // Use debounced function because `isBetaAccessPrivilegeConsumable` or `userData` subscription
          // might rapidly emit identical/successive values leading to redundant API calls.
          this.debounceGetAppsForOrganization();
        }
      });
    this.subscriptions.push(userSub);
  }
  searchOrg(event) {
    this.headerLoader = true;
    this.headerEmpMsg = false;
    if (event.filter !== '' && event.filter !== null) {
      this.searchTextOrg = event.filter?.trim();
    } else {
      this.searchTextOrg = '';
    }
    this.debounceSearchOrg();
  }

  search(event) {
    if (event.filter !== '' && event.filter !== null) {
      this.searchText = event.filter;
      this.isSearchquery = this.searchText !== '';
      this.debounceSearchApp();
    }
  }

  searchAppName() {
    setTimeout(() => {
      $('#vbHeader .p-dropdown-filter-icon').addClass('pi pi-spin pi-spinner');
    }, 10);
    const searchFields = {
      _global: this.searchText
    };
    // Cache suite names from existing apps before search to preserve suite info
    const suiteMap = new Map<string, string>();
    this.apps.forEach((app) => {
      if (app.appType === ApplicationTypes.SUITE && app.id) {
        suiteMap.set(app.id, app.name);
      }
    });
    this.cacheSuiteNames(this.apps);
    this.store.dispatch(
      getAppsBasedOnSearch({
        apiConstants: this.getDropdownApiConstants(),
        searchFields: searchFields,
        start: 0,
        length: 100
      })
    );
    //allAppsList
    const allAppsSub = this.store.select(allAppsList).subscribe((data) => {
      if (!data) {
        return;
      }
      const appList: any = [];
      if (data.length > 0) {
        const allApps = [...data];
        this.cacheSuiteNames(allApps);
        allApps.map((app) => {
          const a = this.getSuiteForMem(app, allApps, suiteMap);
          appList.push(a);
        });
        this.apps = appList;
        this.filteredAppData = appList;
      }
      $('#vbHeader  .p-dropdown-filter-icon').removeClass('pi pi-spin pi-spinner');
      $('#vbHeader  .p-dropdown-filter-icon').addClass('pi pi-search');
    });
    this.subscriptions.push(allAppsSub);
  }

  searchOrgName() {
    setTimeout(() => {
      $('#vbHeader .p-dropdown-filter-icon').addClass('pi pi-spin pi-spinner');
    }, 10);
    this.store.dispatch(
      getOrglistforHeader({
        apiConst: ApiConstants.getOrganizationData,
        searchText: this.searchTextOrg,
        searchQuery: {
          start: 0,
          length: 100
        }
      })
    );
  }

  debounceSearchApp = debounce(this.searchAppName.bind(this), 1500);
  debounceSearchOrg = debounce(this.searchOrgName.bind(this), 1500);

  /**
   * Debounced version of getAppsForOrganization.
   * Prevents duplicate REST API calls when `userData` or `isBetaAccessPrivilegeConsumable` quickly emits multiple times.
   */
  debounceGetAppsForOrganization = debounce(this.getAppsForOrganization.bind(this), 1000);

  /**
   * Debounced version of getDefaultBranches.
   * Prevents duplicate REST API calls when `userData` subscription or NavigationEnd events emit multiple times
   * during app creation or navigation.
   */
  debounceGetDefaultBranches = debounce(this.getDefaultBranches.bind(this), 1000);

  dropdown(event) {
    const allAppsListSub = this.store.select(allAppsList).subscribe((data) => {
      this.results = data;
    });
    this.subscriptions.push(allAppsListSub);
  }

  showMessage(status: string, detail?: string) {
    this.messageService.clear();
    this.messageService.add({
      life: 10000,
      severity: status,
      detail: detail
    });
  }

  generationStatusSub(appId, action?) {
    this.genStsSubscription = this.generationStatus$.subscribe((res) => {
      if (res && res.appId === appId) {
        const generationStatus = res.generationStatus;
        const isGenerationInProgress =
          !this.failedStatus.includes(generationStatus) && !this.successStatus.includes(generationStatus);
        if (isGenerationInProgress) {
          this.genBoolean = true;
        }
        // action will not be there when there is a app change
        if (!action) {
          // check whether the generation is in progress based on latest log status
          if (isGenerationInProgress) {
            this.showProgressBar = !this.silentProgress;
            // update progressbar value based on the selected app
            action = res.generationType;
            this.storePublishAction(action);
            this.value =
              this.publishPrototypeStatus[generationStatus] ||
              this.gitCodePullStatus[generationStatus] ||
              this.gitCodePushStatus[generationStatus] ||
              this.uiLibPushStatus[generationStatus] ||
              this.beLibPushStatus[generationStatus];
          } else {
            this.showProgressBar = false;
            this.headerService.updateProgress(false, this.value);
            return;
          }
        }

        if (this.compilationStatus.includes(generationStatus) && this.value < 80) {
          this.value = this.value + 3;
        } else {
          switch (action) {
            case PublishTypes.PROTOTYPE:
              this.value = this.publishPrototypeStatus[generationStatus];
              break;
            case PublishTypes.PULL:
              this.value = this.gitCodePullStatus[generationStatus];
              break;
            case PublishTypes.PUSH:
              if (this.lastPublishData?.push) {
                this.value = this.gitCodePushStatus[generationStatus];
              } else {
                this.value = this.firstCodePushStatus[generationStatus];
              }
              break;
            case PublishTypes.PUSH_UI_LIBRARIES:
              this.value = this.uiLibPushStatus[generationStatus];
              break;
            case PublishTypes.PUSH_BE_LIBRARIES:
              this.value = this.beLibPushStatus[generationStatus];
              break;
            default:
              // Optionally handle unknown action types
              break;
          }
        }

        if (this.failedStatus.includes(generationStatus) || this.successStatus.includes(generationStatus)) {
          if (!this.generationApiStatus) {
            this.generationApiStatus = this.failedStatus.includes(generationStatus) ? 'error' : 'success';
          }
          const isPublishAction = [
            PublishTypes.PROTOTYPE,
            PublishTypes.PULL,
            PublishTypes.PUSH,
            PublishTypes.PUSH_UI_LIBRARIES,
            PublishTypes.PUSH_BE_LIBRARIES
          ].includes(action as PublishTypes);
          if (generationStatus !== 'PROJECT_CERATION_COMPLETED') {
            let isManuallyPublishedValue = this.appGlobalService.isManuallyPublished({
              appId: appId
            });

            // soft skip of GitPull dialog prompts
            // It's a Workaround, until BE does additional 'origin' field, where initiator is "user-manual" or "rai"
            if (this.genBoolean && isPublishAction && isManuallyPublishedValue) {
              this.showPublishStatus = true;
              this.appGlobalService.updateRecentApp({
                appId: appId,
                action: 'publish-completed'
              });
            }
          }
          // Only show eye icon for Prototype/Push/Pull, NOT for library pushes
          const isLibPush = res.generationType === PublishTypes.PUSH_UI_LIBRARIES ||
                            res.generationType === PublishTypes.PUSH_BE_LIBRARIES;
          if (!isLibPush) {
            this.showEyeIcon = true;
            this.isPrototypePublished = true;
          }
          this.genBoolean = false;
          this.showProgressBar = false;
          this.headerService.updateProgress(false, this.value);
          if (res.compilationStatus === 'COMPILATION_FAILED') {
            this.cloudBuildId = res.compilationBuildId;
            this.compilationFailed = true;
          } else if (res.compilationStatus === 'COMPILATION_SUCCESS') {
            this.compilationFailed = false;
          }
        }
      }
    });
    this.subscriptions.push(this.genStsSubscription);
  }

  getSuiteForMem(app, allApps, suiteMap?: Map<string, string>) {
    let a = {
      name: app.name,
      code: app.name,
      id: app.sid,
      appType: app.applicationType,
      appVersion: app.rappitVersion
    };
    if (app.applicationType === ApplicationTypes.MEMBER) {
      const suiteApp = allApps.find((ap) => ap.sid === app.suiteId || ap.id === app.suiteId);
      if (suiteApp) {
        a = { ...a, ...{ suiteName: suiteApp.name, suiteId: app.suiteId } };
      } else {
        const suiteName = suiteMap?.get(app.suiteId) || this.suiteNameCache.get(app.suiteId);
        if (suiteName) {
          a = { ...a, ...{ suiteName: suiteName, suiteId: app.suiteId } };
        } else {
          a = { ...a, ...{ suiteId: app.suiteId } };
        }
      }
    }
    return a;
  }

  private cacheSuiteNames(apps: any[]): void {
    if (!Array.isArray(apps)) {
      return;
    }

    apps.forEach((app) => {
      const appId = app?.sid || app?.id;
      const appType = app?.applicationType || app?.appType;
      if (appType === ApplicationTypes.SUITE && appId && app?.name) {
        this.suiteNameCache.set(appId, app.name);
      }
    });
  }

  getAppData() {
    const allAppsListSub = this.store.select(appDropList).subscribe((appsData: any) => {
      if (!appsData) {
        return;
      }
      // Skip updating apps list if user is actively filtering in the dropdown
      if (this.searchText) {
        return;
      }
      const appList: any = [];
      if (appsData.length > 0) {
        const allApps = [...appsData];
        this.cacheSuiteNames(allApps);
        allApps.map((app) => {
          const a = this.getSuiteForMem(app, allApps);
          appList.push(a);
        });
        this.apps = appList;
        if (
          !(this.userRole === 'sysAdmin' || this.userRole === 'devAdmin' || this.userRole === 'devViewer') &&
          this.userAppData.length > 0
        ) {
          this.apps = [...this.apps.filter((item) => item.name && !this.userAppData.includes(item.name))];
        }
        // check whether selected app is present in applist
        const selAppPresent = this.apps.find((ap) => ap.id === this.selectedApp.id);
        if (selAppPresent) {
          this.selectedApp = selAppPresent;
        } else if (Object.keys(this.selectedApp).length !== 0) {
          this.selectedApp = this.getSuiteForMem(this.selectedApp, this.apps);
          this.apps = [...this.apps, this.selectedApp];
        }
      }
    });
    this.subscriptions.push(allAppsListSub);

    const selectedAppSub = this.store.select(appData).subscribe(async (app: any) => {
      if (app.recDeleted) {
        this.notifyPageNotFoundAndRedirect(
          'APP_LIST',
          this.translate.instant('APP_DELETED_MESSAGE'),
          this.translate.instant('APP_NOT_FOUND')
        );
      }
      if (app?.name && this.appId != app?.sid) {
        // Only redirect on version mismatch if user is inside an app context (not on app management page)
        if (app?.rappitVersion !== environment.rappitVersion && this.routerAppId !== 'appId') {
          if (app.rappitVersion == environment.rappitNoSqlVersion) {
            this.showWarnAppPop = true;
          } else {
            window.open(
              `${window.location.origin}/${app?.rappitVersion}/#/home/${app.orgId}/${app.sid}/gathering/documents`,
              '_self'
            );
          }
          return;
        }

        // RR2023-31866: Enforce ownership/share access check when an app URL is loaded directly.
        // Admins, devViewers, and Organization Admins bypass this check.
        const isAdminUser =
          this.userRole === 'sysAdmin' ||
          this.userRole === 'devAdmin' ||
          this.userRole === 'devViewer' ||
          this.userRole === 'Organization Admin' ||
          this.user?.sysAdmin ||
          this.user?.devAdmin ||
          this.user?.devViewer;

        if (!isAdminUser && this.routerAppId !== 'appId') {
          const userEmail = this.user?.email;
          const isOwner = app.ownerEmail && userEmail && app.ownerEmail === userEmail;
          const isSharedWith = userEmail && app.sharedWith && userEmail in app.sharedWith;

          if (!isOwner && !isSharedWith) {
            this.confirmationDialogService.confirm({
              message: this.translate.instant('APP_ACCESS_DENIED_MSG'),
              header: this.translate.instant('ACCESS_DENIED_HEADER'),
              icon: 'pi pi-exclamation-triangle',
              acceptLabel: this.translate.instant('OK'),
              rejectVisible: false,
              closable: false,
              accept: () => {
                window.location.href = window.location.origin;
              }
            });
            return;
          }
        }

        this.appGlobalService.write('appId', app.sid);
        this.appGlobalService.write('appRefType', app.refType);
        this.appGlobalService.write('refsName', app.refsName);
        this.appGlobalService.write('parentAppSid', app.parentAppSid || null);
        this.appId = this.appGlobalService.get('appId');
        this.appGlobalService.write('appName', app.name);
        this.appGlobalService.write('applicationType', app.applicationType);
        this.appGlobalService.write('packageName', app.packageName || '');
        this.appGlobalService.write('isDefaultBranch', app.isDefaultBranch || false);
        this.applicationType = app.applicationType;
        this.showBranchDropdown = !!this.bnmVersion && !!app.rappitVersion &&
          app.rappitVersion.localeCompare(this.bnmVersion, undefined, { numeric: true, sensitivity: 'base' }) >= 0;
        if (app.sharedDb) {
          this.appGlobalService.write('sharedDbId', app.sharedDb);
          this.sharedDbId = app.sharedDb;
        }

        if (app.applicationType !== ApplicationTypes.INDEPENDENT) {
          this.appGlobalService.write('suiteId', app.suiteId);
          this.suiteId = app.suiteId;
        }
        this.selectedApp = this.getSuiteForMem(app, this.apps);
        this.selectedAppDispName = this.selectedApp.name;
        this.previousData = this.selectedApp;
        const selAppPresent = this.apps.find((ap) => ap.id === this.selectedApp.id);
        if (!selAppPresent) {
          this.apps = [...this.apps, this.selectedApp];
        }
        const appId = {
          appId: app.sid
        };
        this.gettechStackData();
        this.store.dispatch(
          getAppSettings({
            apiConstants: ApiConstants.getSettingsById,
            appId: this.appGlobalService.get('appId')
          })
        );
        this.utilService.getAppUserTable();
        if (app.projectMenu) {
          this.store.dispatch(setMenuData({ menuData: app?.projectMenu?.menuItems }));
        }
        if (app.rappitVersion) {
          this.appGlobalService.write('appVersion', app.rappitVersion);
        }

        if (app.isPrototypePublished) {
          this.isPrototypePublished = app.isPrototypePublished;
          this.showEyeIcon = true;
        } else {
          this.isPrototypePublished = false;
          this.showEyeIcon = false;
        }

        this.angularFireAuth.signOut().catch((error) => console.error(error));
        await this.signInAndGetFsData();

        // Subscribe to merge status for view-only mode during merge
        // Must be called AFTER _signInAndGetFsData() to ensure Firestore is authenticated
        this.mergeStatusService.subscribeToMergeStatus(app.sid);

        // unsubcribe the previous app's get generation subscription
        if (this.genStsSubscription) {
          this.genStsSubscription.unsubscribe();
          clearTimeout(ApplifecycleEffects.genStatusTimeout);
        }
        clearTimeout(ApplifecycleEffects.genUrlTimeout);
        if (!app?.prototypingAppUrl) {
          this.store.dispatch(
            getGeneratedAppUrl({
              apiConstants: ApiConstants.getAppById,
              sid: app.sid
            })
          );
          const genUrlSub = this.store.select(genUrl).subscribe((genUrlRes: any) => {
            if (genUrlRes?.prototypingAppUrl) {
              this.prototypingAppUrl = genUrlRes.prototypingAppUrl;
              this.genAppUrl = true;
              this.spinner = false;
            } else {
              this.prototypingAppUrl = '';
              this.genAppUrl = false;
              this.spinner = true;
              this.showPublish = false;
            }
          });
          this.subscriptions.push(genUrlSub);
        } else {
          this.genAppUrl = true;
          this.spinner = false;
          this.prototypingAppUrl = app.prototypingAppUrl;
          this.store.dispatch(setGenStatus({ genStatus: null }));
        }
        const curPageSub = this.curPage.subscribe((data) => {
          this.currentPage = data;

          if (data && data !== 'settings' && data !== 'dashboards') {
            this.updateDocumentTitle();
          }
        });
        this.subscriptions.push(curPageSub);
      }
    });

    this.subscriptions.push(selectedAppSub);
  }

  getCodeGenerationStatus() {
    //check generationLogAppId to know if this subscription is for the current app.
    if (this.codeGenerationLogSub$ && this.generationLogAppId === this.appGlobalService.get('appId')) {
      return;
    }
    // Subscription exists but is for a different app â€” unsubscribe before creating a new one.
    if (this.codeGenerationLogSub$) {
      this.codeGenerationLogSub$.unsubscribe();
    }
    this.generationLogAppId = this.appGlobalService.get('appId');

    const queryObject = {
      collectionName: `GenerationLog`,
      filter: [
        {
          field: 'appId',
          operator: '==',
          value: this.appGlobalService.get('appId')
        },
        {
          field: 'recDeleted',
          operator: '==',
          value: false
        }
      ],
      orderby: { field: 'modifiedDate', dir: 'desc' }
    };

    try {
      this.codeGenerationLogSub$ = this.fsBaseService.fireService(queryObject).subscribe(
        (res: any[]) => {
          if (res.length) {
            this.showProgressBar = !this.silentProgress;
            const latestLog = res[0].payload.doc.data();
            this.store.dispatch(setGenStatus({ genStatus: latestLog }));

            // Store all generation logs on first load
            if (this.generationLogs.length === 0) {
              this.generationLogs = res.map((r) => r.payload.doc.data());
              const hasPushCompleted = this.generationLogs.some(
                (log) => log.generationStatus === 'PUBLISH_COMPLETED' && log.generationType === PublishTypes.PUSH
              );
              this.headerService.gitPushHappened$.next(hasPushCompleted);
            }

            // If current log is PUBLISH_COMPLETED, append to generationLogs
            if (latestLog.generationStatus === 'PUBLISH_COMPLETED') {
              this.generationLogs.unshift(latestLog);
              if (latestLog.generationType === PublishTypes.PUSH) {
                this.headerService.gitPushHappened$.next(true);
              }
            }

            // Update lastCompletedPublishData from generationLogs
            this.updateLastCompletedPublishData();

            // Keep existing behavior for publishing dropdown
            this.getPublishStatus(res[0].payload.doc.data());
          }
        },
        (err: any) => {
          console.error('Error fetching code generation status documents:', err);
        }
      );
      this.subscriptions.push(this.codeGenerationLogSub$);
    } catch (error) {
      console.error('Error while fetching code generation status:', error);
    }
  }

  updateDocumentTitle() {
    this.titleService.setTitle(this.selectedApp.name);

    //localStorage.setItem("evaPageTitle", this.selectedApp.name)
    this.appGlobalService.write('evaPageTitle', this.selectedApp.name);
    this.text = this.selectedApp.name;
  }

  attachAppId(appId: string) {
    // unsubcribe the previous app's get generation subscription
    if (this.genStsSubscription) {
      this.genStsSubscription.unsubscribe();
      clearTimeout(ApplifecycleEffects.genStatusTimeout);
    }
    const dataSetMap = new Map<string, string>();
    this.store.dispatch(
      setAppId({
        appId
      })
    );
    //this.appGlobalService.write('appId', appId);
  }

  reloadCurrentRoute(appInfo: any) {
    // reset SessionId in mainLayout and revise URLparam
    this.headerService.triggerOpenSessions();

    const currentUrl = this.router?.url?.split('?')?.[0];
    const urlArray = currentUrl.split('/');
    this.angularFireAuth.signOut().catch((error) => console.error(error));
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => {
        this.router
          .navigate(['/home', urlArray[2], appInfo?.id, urlArray[4], urlArray[5]], { relativeTo: this.activatedRoute })
          .catch((error) => console.error(error));
        this.selectedApp = appInfo;
        if (
          !(this.userRole === 'sysAdmin' || this.userRole === 'devAdmin' || this.userRole === 'devViewer') &&
          this.userAppData.length > 0
        ) {
          this.apps = [...this.apps.filter((item) => item.name && !this.userAppData.includes(item.name))];
        }
      })
      .catch((error) => console.error(error));
  }

  appChange(event: any) {
    const nextAppId = event.value?.id;
    this.appGlobalService.clearAppInfo();
    this.appGlobalService.write('appId', nextAppId);

    if (this.isBetaAccessPrivilegeConsumable) {
      const raiModeEnabledForCurrentApp = this.appGlobalService.isRaiModeEnabledForAppId(nextAppId);

      if (raiModeEnabledForCurrentApp === undefined) {
        // first time navigation inside application
        this.appGlobalService.updateRaiModeEnabledForAppId(true, nextAppId);
      }
    }

    this.resetPublishState();
    // localStorage.setItem("appId", event.value?.id);
    //this.attachAppId(event.value?.id);

    this.titleService.setTitle(event.value?.name);

    localStorage.setItem('evaPageTitle', event.value?.name);
    // this.attachAppId(this.selectedApp.sid);
    this.reloadCurrentRoute(event.value);
    // if(!this.utilService.value){
    this.selectedApp = event.value;
    this.previousData = this.selectedApp;
  }

  private resetPublishState(): void {
    this.showPublishStatus = false;
    this.showProgressBar = false;
    this.showNotification = false;
    this.generationApiStatus = null;
    this.generationApiError = null;
    this.lastPublishData = {};
    this.lastCompletedPublishData = {};
    this.generationLogs = [];
    this.compilationFailed = null;
    this.value = 0;
    // Reset app tracker so getCodeGenerationStatus() knows to create a new subscription
    this.generationLogAppId = null;
  }

  onDropdownShow() {
    if (this.dropdownEle1) {
      this.dropdownEle1.resetFilter();
    }
  }

  orgDropdownHidden() {
    this.searchTextOrg = '';
    this.headerLoader = false;
  }

  closeWarnPopup() {
    this.showWarnAppPop = false;
  }

  handleAppSelectionChange(event: any) {
    // this.destroy$.next(true);
    // this.destroy$.unsubscribe();

    if (!this.utilService.value || !this.getPendingService.isPending.getValue()) {
      if (event.value?.appVersion == environment.rappitVersion) {
        // unsubcribe the previous app's get generation subscription
        if (this.genStsSubscription) {
          this.genStsSubscription.unsubscribe();
          clearTimeout(ApplifecycleEffects.genStatusTimeout);
        }
        this.appChange(event);
      } else if (event.value.appVersion == environment.rappitNoSqlVersion) {
        this.showWarnAppPop = true;
        this.selectedApp = this.previousData?.name;
      } else {
        this.loader.show();

        const selectedAppId = event.value.id;
        let fallbackRouteArr: any;

        if (this.isBetaAccessPrivilegeConsumable) {
          fallbackRouteArr = ['prototyping', 'preview'];

          const raiModeEnabledForCurrentApp = this.appGlobalService.isRaiModeEnabledForAppId(selectedAppId);

          if (raiModeEnabledForCurrentApp === undefined) {
            // first time navigation inside application

            this.appGlobalService.updateRaiModeEnabledForAppId(true, selectedAppId);
          } else if (raiModeEnabledForCurrentApp == false) {
            fallbackRouteArr = ['gathering', 'documents'];
          }
        } else {
          fallbackRouteArr = ['gathering', 'documents'];
        }

        window.open(
          `${window.location.origin}/${event.value?.appVersion}/#/home/${this.routerOrgId}/${selectedAppId}/${fallbackRouteArr.join('/')}`,
          '_self'
        );
      }
    } else {
      this.confirmationDialogService.confirm({
        message: this.getPendingService.isPending.getValue()
          ? this.translate.instant('SAVE_VALID_STRING')
          : this.translate.instant('ENV_VALID_STRING'),
        header: this.translate.instant('CONFIRMATION'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.appChange(event);
          if (!this.getPendingService.isPending.getValue()) {
            this.utilService.setService(false);
          }
        },
        reject: () => {
          this.selectedApp = this.previousData;
        }
      });
      this.getDefaultBranches();
      const hasPendingChanges = this.utilService.value || this.getPendingService.isPending.getValue();

      if (!hasPendingChanges) {
        this.processAppVersionChange(event);
        return;
      }
      this.showPendingChangesConfirmation(event);
    }
  }

  private processAppVersionChange(event: any): void {
    const appVersion = event.value?.appVersion;

    if (appVersion == environment.rappitVersion) {
      this.cleanupAndChangeApp(event);
      return;
    }

    if (appVersion == environment.rappitNoSqlVersion) {
      this.showWarnAppPop = true;
      this.selectedApp = this.previousData?.name;
      return;
    }

    this.loader.show();
    window.open(
      `${window.location.origin}/${appVersion}/#/home/${this.routerOrgId}/${event.value.id}/gathering/documents`,
      '_self'
    );
  }

  private cleanupAndChangeApp(event: any): void {
    // unsubscribe the previous app's get generation subscription
    if (this.genStsSubscription) {
      this.genStsSubscription.unsubscribe();
      clearTimeout(ApplifecycleEffects.genStatusTimeout);
    }
    if (this.codeGenerationLogSub$) {
      this.codeGenerationLogSub$.unsubscribe();
    }
    this.appChange(event);
  }

  private showPendingChangesConfirmation(event: any): void {
    const isPending = this.getPendingService.isPending.getValue();
    const message = isPending
      ? this.translate.instant('SAVE_VALID_STRING')
      : this.translate.instant('ENV_VALID_STRING');

    this.confirmationDialogService.confirm({
      message,
      header: this.translate.instant('CONFIRMATION'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.appChange(event);
        if (!isPending) {
          this.utilService.setService(false);
        }
      },
      reject: () => {
        this.selectedApp = this.previousData;
      }
    });
  }

  private handleRouteParamsChange(): void {
    const isInvalidOrgRoute = this.routerOrgId.includes('settings') || !this.routerOrgId.includes('-');
    const isNavigatingToArtifacts = this.routerAppId && this.routerAppId !== 'appId';
    const shouldDispatchGetApp = isNavigatingToArtifacts && !(this.menuData && this.menuData.length);

    if (isInvalidOrgRoute) {
      this.handleInvalidOrgRoute();
      return;
    }

    if (shouldDispatchGetApp) {
      this.store.dispatch(
        getSidBasedApps({
          apiConstants: ApiConstants.getAppById,
          sid: this.routerAppId
        })
      );
    }
  }

  private handleInvalidOrgRoute(): void {
    if (this.user) {
      const orgId = this.appGlobalService.get('user') ? this.appGlobalService.get('user').orgIds[0] : '';
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => {
          this.router
            .navigate(['/home', orgId, 'appId', 'settings', 'appmanagement'], {
              relativeTo: this.acRoute
            })
            .catch((error) => console.error(error));
        })
        .catch((error) => console.error(error));
    } else {
      this.showMessage('error', 'The Rappit Url is incorrect, please try to logout and login');
    }
    // unsubscribe the previous app's get generation subscription if it is navigated back to app management page
    if (this.genStsSubscription) {
      this.genStsSubscription.unsubscribe();
      clearTimeout(ApplifecycleEffects.genStatusTimeout);
    }
    if (this.codeGenerationLogSub$) {
      this.codeGenerationLogSub$.unsubscribe();
    }
    this.resetPublishState();
  }

  /** Navigates back to the app management home page using Angular router. */
  backToHome(): void {
    if (this.isMenuCollapsed) {
      this.isMenuCollapsed = false;
      this.dispatchMenuCollapsedEvent();
    }
    const orgId = this.routerOrgId || this.appGlobalService.get('orgId');
    this.router
      .navigate(['/home', orgId, 'appId', 'settings', 'appmanagement'])
      .catch((error) => console.error('[Header] backToHome navigation failed:', error));
  }

  openPrototypeInNewTab() {
    if (this.isPrototypePublished) {
      window.open(this.prototypingAppUrl, '_blank');
    } else {
      this.showPrototypePopup = true;
      setTimeout(() => {
        this.showPrototypePopup = false;
      }, 3500);
    }
  }

  handleOrgSelectionChange(event: any) {
    // Reset search filter and restore original org list after selection
    this.searchTextOrg = '';
    this.getOrgList();

    // Update selected organization and persist selection
    this.selectedOrg = event.value;
    this.appGlobalService.write('orgId', this.selectedOrg?.sid);
    this.appGlobalService.write('clearSearch', true);

    // Fetch organization-specific data and update UI
    this.store.dispatch(
      getOrgDataForHeader({
        orgApi: ApiConstants.getOrganizationById,
        sid: this.selectedOrg?.sid
      })
    );

    const currentUrl = this.router.url;
    const urlArray = currentUrl.split('/');
    this.store.dispatch(setApps({ appList: [] }));
    this.store.dispatch(setAllApps({ allAppList: [], totalRecords: 0 }));
    this.store.dispatch(setUsers({ usersData: [], totalRecords: 0 }));
    this.getUserRole();
    this.getDefaultBranches();
    if (this.userRole && this.userRole !== 'Viewer' && this.userRole !== 'Prototype Viewer') {
      this.getUsersForSearch();
    }
    this.selectedApp = {};
    if (this.router.url.includes('manageusers') || this.router.url.includes('getOrgDetail')) {
      if (
        !(
          this.userRole === 'sysAdmin' ||
          this.userRole === 'devAdmin' ||
          this.userRole === 'devViewer' ||
          this.userRole === 'Organization Admin'
        )
      ) {
        this.router
          .navigate(['/home', this.selectedOrg?.sid, 'appId', 'settings', 'appmanagement'])
          .catch((error) => console.error(error));
      } else if (this.router.url.includes('manageusers')) {
        this.router
          .navigate(['/home', this.selectedOrg?.sid, 'appId', urlArray[4], urlArray[5]], {
            relativeTo: this.activatedRoute
          })
          .catch((error) => console.error(error));
        this.getUsersForOrganization();
      } else {
        this.router
          .navigate(['/home', this.selectedOrg?.sid, 'appId', urlArray[4], urlArray[5]], {
            relativeTo: this.activatedRoute
          })
          .catch((error) => console.error(error));
        this.getOrgById();
      }
    } else {
      this.router
        .navigate(['/home', this.selectedOrg?.sid, 'appId', urlArray[4], urlArray[5]], {
          relativeTo: this.activatedRoute
        })
        .catch((error) => console.error(error));
    }
  }

  getDefaultBranches() {
    const userId = this.user?.sid || '';
    const orgId = this.appGlobalService.get('orgId') || '';
    if (!userId || !orgId) {
      console.log('Missing userId or orgId, skipping API call');
      return;
    }
    this.baseService.get(ApiConstants.getDefaultBranches, { userId, orgId }).subscribe({
      next: (response: any) => {
        if (response?.defaultBranches) {
          this.appGlobalService.write('defaultBranches', response.defaultBranches);
          console.log('Default branches set successfully in Global Service:', response.defaultBranches);
        } else {
          this.appGlobalService.write('defaultBranches', {});
        }
      },
      error: (error: any) => {
        this.appGlobalService.write('defaultBranches', {});
      }
    });
  }

  getUsersForOrganization() {
    this.store.dispatch(
      getUsers({
        apiConstants: ApiConstants.getUsers,
        filter: {
          start: 0,
          length: 100
        },
        orgChange: true
      })
    );
  }
  getUsersForSearch() {
    this.store.dispatch(
      getUsersForSearch({
        apiConstants: ApiConstants.getUsersForSearch,
        filter: {
          start: 0,
          length: 100
        },
        orgChange: true
      })
    );
  }
  getAppsForOrganization() {
    const apiConstants = this.getDropdownApiConstants();
    this.store.dispatch(
      getAppsForOrg({
        getAppsApiConstants: apiConstants,
        filter: {
          start: 0,
          length: 100,
          queryParams: {
            createdWithRai: this.isBetaAccessPrivilegeConsumable
          }
        },
        orgChange: true
      })
    );
  }

  private getDropdownApiConstants() {
    const orgId = this.selectedOrg?.sid ? this.selectedOrg?.sid : this.appGlobalService.get('orgId');
    const currentAppId = this.appGlobalService.get('appId');
    const hasCurrentApp = currentAppId && currentAppId !== 'appId';
    const apiConstants = hasCurrentApp ? { ...ApiConstants.getAppsListForDropdown } : { ...ApiConstants.getAppsListForOrg };
    apiConstants.url += hasCurrentApp ? `${currentAppId}` : `${orgId}`;
    return apiConstants;
  }

  getOrgById() {
    this.store.dispatch(
      getSidBasedOrManagement({
        apiConstants: ApiConstants.getOrganizationById,
        sid: this.selectedOrg?.sid
      })
    );
  }

  getUserRole() {
    // Reset menu before reconstructing based on new org/role
    this.menuJSON = [];
    this.initializeRouterOrgId();

    // Handle system-level admin roles first
    if (this.user.devAdmin || this.user.sysAdmin) {
      this.handleSystemAdminRole();
      return;
    }

    // Handle organization-level roles
    this.handleOrgLevelRole();
    this.showToolsMenu();
  }

  private initializeRouterOrgId() {
    if (this.selectedOrg?.sid) {
      this.routerOrgId = this.selectedOrg.sid;
    } else {
      this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
        this.routerOrgId = params.get('orgId');
      });
    }
  }

  private handleSystemAdminRole() {
    this.menuJSON = [
      this.createMenuItem('manageorgs', 'Icon _ Dropdown _ List.svg', 'ORG_LIST'),
      this.createMenuItem('manageusers', 'Icon _ Dropdown _ User.svg', 'USER_MANAGEMENT'),
      this.createMenuItem('appmanagement', 'Icon _ Dropdown _ Apps.svg', 'APP_MANAGEMENT')
    ];

    if (this.user.devAdmin) {
      this.userRole = 'devAdmin';
      this.menuJSON.push({
        src: 'assets\\images\\svg\\Icon _ Dropdown _ Apps.svg',
        label: this.maintenanceLabel
      });
    } else {
      this.userRole = 'sysAdmin';
    }

    this.showToolsMenu();

    this.updateUserKebabMenu();
  }

  private handleOrgLevelRole() {
    const orgId = this.appGlobalService.get('orgId');
    const orgRole = this.user.orgInfos?.[orgId];
    this.userRole = orgRole;

    const roleHandled = this.assignMenuForOrgRole(orgRole);

    // Fallback to devViewer if user has devViewer flag but no specific org role was handled
    if (!roleHandled && this.user.devViewer) {
      this.userRole = 'devViewer';
      this.menuJSON = this.getAppAndOrgListMenu();
    }

    // Default fallback menu
    if (!this.menuJSON?.length) {
      this.menuJSON = [this.createMenuItem('appmanagement', 'Icon _ Dropdown _ Apps.svg', 'APP_MANAGEMENT')];
    }
  }

  private assignMenuForOrgRole(orgRole: string): boolean {
    const rolesWithAppAndOrgList = ['Developer', 'Consultant', 'Viewer', 'Architect'];

    if (orgRole === 'Organization Admin') {
      this.userRole = 'Organization Admin';
      this.menuJSON = this.getOrgAdminMenu();
      return true;
    }

    if (rolesWithAppAndOrgList.includes(orgRole) && this.user.devViewer) {
      this.menuJSON = this.getAppAndOrgListMenu();
      return true;
    }

    if (orgRole === 'Prototype Viewer' && this.user.devViewer) {
      // Prototype Viewer with devViewer - no menu assigned, handled by fallback
      return true;
    }

    return false;
  }

  private getOrgAdminMenu() {
    return [
      this.createMenuItem('getOrgDetail', 'Icon _ Dropdown _ List.svg', 'VIEW_ORG'),
      this.createMenuItem('manageusers', 'Icon _ Dropdown _ User.svg', 'USER_MANAGEMENT'),
      this.createMenuItem('appmanagement', 'Icon _ Dropdown _ Apps.svg', 'APP_MANAGEMENT')
    ];
  }

  private getAppAndOrgListMenu() {
    return [
      this.createMenuItem('appmanagement', 'Icon _ Dropdown _ Apps.svg', 'APP_MANAGEMENT'),
      this.createMenuItem('manageorgs', 'Icon _ Dropdown _ List.svg', 'ORG_LIST')
    ];
  }

  private createMenuItem(page: string, icon: string, label: string) {
    return {
      routerLink: `/home/${this.routerOrgId}/appId/settings/${page}`,
      src: `assets\\images\\svg\\${icon}`,
      label
    };
  }

  showToolsMenu() {
    // DeltaSQL Menuservic
    const orgId = this.appGlobalService.get('orgId');
    let role = this.user.orgInfos?.[orgId];
    const isViewerRole = role === 'Viewer' || role === 'Prototype Viewer' || this.userRole === 'devViewer';
    const toolsMenuExists = this.menuJSON.some((item) => item.label === 'TOOLS');
    if (role === undefined) {
      if (this.user.devAdmin) {
        role = 'devAdmin';
      } else if (this.user.sysAdmin) {
        role = 'sysAdmin';
      } else if (this.user.devViewer) {
        role = 'devViewer';
      }
    }
    if (!isViewerRole && !toolsMenuExists) {
      this.menuJSON.push({
        label: 'TOOLS',
        children: [
          {
            onClick: this.openDeltaSQLGenerationModal.bind(this),
            iconClass: 'fa-solid fa-file-code',
            label: 'DELTA_SQL',
            id: 'DELTA_SQL'
          }
        ],
        scenario: 'TOOLS'
      });
    }
  }

  openDeltaSQLGenerationModal() {
    const deltaSQLModal = this.dialogService.open(DeltaSqlGenerationComponent, {
      showHeader: false,
      styleClass: 'delta-sql',
      modal: true,
      data: {
        title: 'Delta SQL'
      },
      width: '95%',
      height: '95%'
    });
  }

  getOrgList() {
    // Unsubscribe from previous org list subscription if it exists to prevent memory leaks and duplicate data handling
    if (this.orgListForHeader$) {
      this.orgListForHeader$?.unsubscribe();
    }

    // Fetch org list for dropdown by dispatching action with empty search text to get all orgs. The list will be filtered on frontend based on user role
    this.store.dispatch(
      getOrglistforHeader({
        apiConst: ApiConstants.getOrganizationData,
        searchText: '',
        searchQuery: {
          start: 0,
          length: 100
        }
      })
    );

    // Subscribe to org list data and filter based on user role
    this.orgListForHeader$ = this.store.select(orglistForHeader).subscribe((data: any) => {
      if (!data) {
        return;
      }

      if (data.length === 0) {
        this.headerEmpMsg = true;
        this.headerLoader = false;
      } else {
        if (this.user.devAdmin || this.user.sysAdmin || this.user.devViewer) {
          this.orgs = data;
        } else {
          this.orgs = data.filter((org) => this.user.orgIds.includes(org.sid));
        }

        if (!this.searchTextOrg) {
          this.userOrgs = [...this.orgs];
        }

        const org: any = this.orgs.find((e) => e.sid === this.selectedOrg?.sid);
        if (!org && this.selectedOrg?.sid) {
          this.orgs = [...this.orgs, this.selectedOrg];
          this.userOrgs = [...this.orgs];
          this.headerLoader = false;
        }
        if (!this.selectedOrg) {
          const orgId =
            this.appGlobalService.get('invalidUrl') === 'true' ? this.appGlobalService.get('orgId') : this.routerOrgId;
          this.selectedOrg = this.orgs.find((orgn) => orgn.sid === orgId);
        }
      }
    });

    // Store the subscription so that it can be unsubscribed later to prevent memory leaks
    this.subscriptions.push(this.orgListForHeader$);
  }

  private syncSelectedOrgIntoOrgLists() {
    if (!this.selectedOrg?.sid) {
      return;
    }

    const selectedOrgExists = this.orgs?.some((org) => org?.sid === this.selectedOrg?.sid);
    if (!selectedOrgExists) {
      this.orgs = [...(this.orgs || []), this.selectedOrg];
    }

    if (this.userOrgs?.length) {
      const selectedUserOrgExists = this.userOrgs.some((org) => org?.sid === this.selectedOrg?.sid);
      if (!selectedUserOrgExists) {
        this.userOrgs = [...this.userOrgs, this.selectedOrg];
      }
    }
  }

  hideDropdown() {
    // this.dropdownEle.hide();
    this.dropdownEle1?.hide();
  }

  navigateMenu(menu) {
    const label = menu.label;
    if (label === 'STOP_MAINTENANCE' || label === 'START_MAINTENANCE') {
      this.trigerMaintenance = !this.trigerMaintenance;
      if (this.trigerMaintenance) {
        this.maintenanceLabel = 'STOP_MAINTENANCE';
      } else {
        this.maintenanceLabel = 'START_MAINTENANCE';
      }
      this.menuJSON.find((m) => m.label === 'START_MAINTENANCE' || m.label === 'STOP_MAINTENANCE').label =
        this.maintenanceLabel;
      const api = { ...ApiConstants.maintenance };
      api.url = `${api.url}?maintenance=${this.trigerMaintenance}`;
      this.baseService.post(api).subscribe({
        next: (response: any) => {
          /* empty */
        },
        error: () => console.info('error occurred')
      });
    }
    if (menu.routerLink) {
      window.open(`${window.location.origin}/#/${menu.routerLink}`, '_self');
    }
  }

  handleAppConnectivityChanges() {
    this.subscriptions.push(
      this.appGlobalService.isOnline$.subscribe((isOnline) => {
        if (isOnline) {
          this.eventTracker.stop('onlineEvent');
          console.log(`onlineEvent : ${this.eventTracker.trackedEvents.onlineEvent?.duration}`);
          console.log('Online...');
          this.eventTracker.start('onlineEvent');
        } else {
          this.eventTracker.stop('offlineEvent');
          console.log(`offlineEvent : ${this.eventTracker.trackedEvents.offlineEvent?.duration}`);
          console.log('Offline...');
          this.unSubscribeListener();
          this.eventTracker.start('offlineEvent');
        }
      })
    );
  }

  fetchMaintenanceStatus() {
    const appId = this.appGlobalService.get('appId');
    this.appGlobalService.write('maintananceStatus', undefined);
    this.appGlobalService.write('bulkRoleCopyStatus', undefined);
    this.appGlobalService.write('metaInfoReadingStatus', undefined);

    let generationStatusQueryObject = {};

    if (appId) {
      generationStatusQueryObject = {
        collectionName: 'GenerationStatus',
        filter: [
          {
            field: 'appId',
            operator: 'in',
            value: [this.appGlobalService.get('appId'), 'ALL']
          },
          {
            field: 'recDeleted',
            operator: '==',
            value: false
          }
        ]
      };
    } else {
      generationStatusQueryObject = {
        collectionName: 'GenerationStatus',
        filter: [
          {
            field: 'appId',
            operator: '==',
            value: 'ALL'
          },
          {
            field: 'recDeleted',
            operator: '==',
            value: false
          }
        ]
      };
    }

    if (this.maintenanceModeSub$) {
      this.maintenanceModeSub$.unsubscribe();
    }

    this.maintenanceModeSub$ = this.fsBaseService.fireService(generationStatusQueryObject).subscribe(
      (res) => {
        this.setMaintenance(res);
      },
      (error) => {
        console.error(error);
      }
    );

    this.attachGenerationStatusListnerSubscription.push(this.maintenanceModeSub$);
  }

  fetchBranchingStatus() {
    const currentAppId = this.appGlobalService.get('appId');
    if (!currentAppId || currentAppId === 'appId') {
      this.maintainBranchingMaintenance([]);
      return;
    }

    console.log('Fetching branching status for appId:', currentAppId);
    const byAppQueryObject = {
      collectionName: 'BranchingStatus',
      filter: [
        {
          field: 'appId',
          operator: '==',
          value: currentAppId
        }
      ]
    };

    const byTargetBranchQueryObject = {
      collectionName: 'BranchingStatus',
      filter: [
        {
          field: 'targetBranchId',
          operator: '==',
          value: currentAppId
        }
      ]
    };

    if (this.branchingStatusByAppSub$) {
      this.branchingStatusByAppSub$.unsubscribe();
    }
    if (this.branchingStatusByTargetSub$) {
      this.branchingStatusByTargetSub$.unsubscribe();
    }

    this.cloneStatusMap.clear();
    this.isCloneInProgress = false;
    this.utilService.resetBranchMaintenanceState();

    let byAppRecords: any[] = [];
    let byTargetRecords: any[] = [];
    let branchingStatusDebounceTimer: ReturnType<typeof setTimeout> | null = null;

    const emitMergedBranchingStatus = () => {

        const merged = [...byAppRecords, ...byTargetRecords];
        const uniqueRecordMap = new Map<string, any>();

        for (const record of merged) {
          const docId = record?.payload?.doc?.id;
          if (docId) {
            uniqueRecordMap.set(docId, record);
          }
        }

        const uniqueRecords = uniqueRecordMap.size ? Array.from(uniqueRecordMap.values()) : merged;
        this.maintainBranchingMaintenance(uniqueRecords);
    };

    this.branchingStatusByAppSub$ = this.fsService.fireService(byAppQueryObject).subscribe(
      (res) => {
        byAppRecords = res || [];
        emitMergedBranchingStatus();
      },
      (error) => {
        console.error(error);
      }
    );

    this.branchingStatusByTargetSub$ = this.fsService.fireService(byTargetBranchQueryObject).subscribe(
      (res) => {
        byTargetRecords = res || [];
        emitMergedBranchingStatus();
      },
      (error) => {
        console.error(error);
      }
    );

    this.attachGenerationStatusListnerSubscription.push(this.branchingStatusByAppSub$, this.branchingStatusByTargetSub$);
  }

  maintainBranchingMaintenance(res: any[]) {
    const currentAppId = this.appGlobalService.get('appId');
    if (!currentAppId || currentAppId === 'appId' || currentAppId === 'ALL') {
      return;
    }

    const records = res || [];
    let branchMaintenanceStatus: string | null = null;



    // Update cloneStatus map from the changed records (stateChanges() only emits deltas).
    for (const dt of records) {
      const doc = dt?.payload?.doc;
      const rec = doc?.data?.();
      const docId = doc?.id;
      if (!doc || !rec || !docId) {
        continue;
      }
      if (rec.recDeleted) {
        this.cloneStatusMap.delete(docId);
        this.BranchingStatusMap.delete(docId);
      } else {
        this.cloneStatusMap.set(docId, rec.cloneStatus);
        this.BranchingStatusMap.set(docId, rec.branchMaintenanceStatus);
      }
    }
    const branchingStatusEntries = Array.from(this.BranchingStatusMap.entries());
    const branchingStatuses = branchingStatusEntries.map(([, status]) => status);
    const inProgressStatus = branchingStatuses.find((status) => this.utilService.blockedStatus.includes(status));
    if (inProgressStatus) {
      if (!this.targetBranchCreationInProgress) {
        this.maintainAppEditablity(inProgressStatus, currentAppId);
      }
    } else if (this.targetBranchCreationInProgress) {
      this.maintainAppEditablity('BRANCH_CREATION_COMPLETED', currentAppId);
    }

    this.isCloneInProgress = Array.from(this.cloneStatusMap.values()).includes('CLONING_STARTED');
}

  /**
   * Checks if there are multiple in-progress branching operations for the current app, which would indicate parallel branch creation and affect maintenance mode handling.
   * @param statuses - Array of branching status strings associated with the current app as the source
   * @returns true if there are multiple in-progress branching operations, false otherwise.
   */
  checkParallelBranchCreation(statuses: string[]): boolean {
    const inProgressStatuses = statuses.filter(status =>
      this.utilService.blockedStatus.includes(status)
    );
    return inProgressStatuses.length > 1;
  }

  updatePublishButtonVisibility() {
    this.store.select(userData).subscribe((userDataRes: any) => {
      if (userDataRes) {
        this.user = userDataRes;
        const userOrgInfo = this.user.orgInfos;
        const orgId = this.appGlobalService.get('orgId');

        this.role = userOrgInfo?.[orgId] ?? '';
      }
    });
    this.showPublish = true;
    if (
      this.user.devViewer &&
      this.role !== 'Organization Admin' &&
      this.role !== 'Architect' &&
      this.role !== 'Developer' &&
      this.role !== 'Consultant'
    ) {
      this.showPublish = false;
    } else if (this.role === 'Viewer' || this.role === 'Prototype Viewer') {
      this.showPublish = false;
    }
  }

  ngOnInit(): void {
    this.updateActiveArtifactTabFromUrl(this.router.url);
    this.dispatchMenuCollapsedEvent();

    const appSub = this.store.select(selectedAppData).subscribe((app: any) => {
      if (app) {
        // we need to fix this, once Merge-approval process's tasks are wrapped, which are part of Priority_1
        if (app.sid) {
          this.listenToChatSessionList(app);
          this.getCodeGenerationStatus();
          this.generationStatusSub(this.appId);
        }
      }
    });
    this.subscriptions.push(appSub);

    this.headerService.publishAction$.pipe(takeUntil(this.destroy$)).subscribe(({ type, data }) => {
      if (type === 'PROTOTYPE' || type === 'PUSH' || type === 'PULL') {
        this.showConfirmPublish(type);
      } else if (type === 'GENERATE') {
        this.silentProgress = data.silentProgress === true;
        this.godeGenerationAction = data.action;
        this.storePublishAction(data.action);
        if (data.ignoreWarnings !== undefined) {
          this.allowPublishWarn = data.ignoreWarnings;
        }
        this.codeGeneration();
      } else if (type === 'VIEW_NOTIFICATION') {
        this.viewNotification();
      }
    });

    this.headerService.logoutAction$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (thatResponse: any) => {
        this.triggerLogout();
      }
    });

    if (this.appGlobalService.get('appId') === 'appId') {
      this.signInAndGetFsData().catch((error) => console.error(error));
    }

    this.updatePublishButtonVisibility();

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: any) => {
      this.raiModeEnabledForApp = this.appGlobalService.isRaiModeEnabledForApp();
      this.isBetaAccessPrivilegeConsumable = this.appGlobalService.isBetaAccessPrivilegeConsumable();
      this.isBetaAccessPrivilegeConsumableForApp = this.appGlobalService.isBetaAccessPrivilegeConsumableForApp();

      this.updatePublishButtonVisibility();

      this.updateUserKebabMenu();

      this.updateActiveArtifactTabFromUrl(event.urlAfterRedirects || event.url);
    });

    let user;

    try {
      const auth = this.appGlobalService.get('auth');
      if (auth) {
        const userInfo = JSON.parse(auth)?.userData;
        user = userInfo?.email ? userInfo : null;
        this.appGlobalService.write('user', userInfo);
        this.appGlobalService.write('userEmail', userInfo?.email);
        this.appGlobalService.write('userOrgId', userInfo?.orgId);
      }
    } catch (e) {
      console.error(e);
    }

    this.handleAppConnectivityChanges();

    if (MetaInfoStaticData.length > 0) {
      const d = JSON.parse(JSON.stringify(this.appGlobalService.get('appmetaInfo'))) || {};
      MetaInfoStaticData.forEach((data) => {
        d[data.id] = data.name;
      });
      this.appGlobalService.write('appmetaInfo', d);
      this.store.dispatch(setAppMetaInfo({ metaInfo: d }));
    }

    // Initialize queryStrings as empty map - will be populated from appMetaInfo when model === 'querystring'
    if (!this.appGlobalService.get('queryStrings')) {
      this.appGlobalService.write('queryStrings', {});
    }

    const getSubscription = this.store.select(usersSearchData).subscribe((data: any) => {
      if (data && data?.usersData?.length > 0) {
        this.appGlobalService.write('allUsers', data.usersData);
      }
    });
    this.subscriptions.push(getSubscription);

    // Subscribe to merge status for banner display
    this.mergeStatusSubscription = this.mergeStatusService.mergeStatus$.subscribe((status) => {
      this.mergeStatusInfo = status.isMergeInProgress ? status : null;
    });

    const params = {
      email: this.appGlobalService.get('userEmail'),
      orgid: this.appGlobalService.get('userOrgId')
    };

    if (this.appGlobalService.get('invalidUrl') === 'true') {
      if (this.appGlobalService.get('orgId') === '') {
        this.triggerLogout();
        this.showMessage('error', this.translate.instant('NO_ORGANIZATION_FOR_USER'));
      } else {
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router
              .navigate(['/home', this.appGlobalService.get('orgId'), 'appId', 'settings', 'appmanagement'], {
                relativeTo: this.activatedRoute
              })
              .catch((error) => console.error(error));
          })
          .catch((error) => console.error(error));
      }
      this.router
        .navigate(['/home', this.appGlobalService.get('orgId'), 'appId', 'settings', 'appmanagement'])
        .catch((error) => console.error(error));
    }

    const delOrDeactiveOrg = this.store.select(selectedOrgDeleted).subscribe((data: any) => {
      if (data) {
        try {
          // Use store-subscribed user data instead of localStorage
          const userInfo = { ...this.user };
          const orgIds = [...(userInfo.orgIds || [])];
          const idIndex = orgIds.findIndex((r) => r === this.selectedOrg?.sid);
          if (idIndex > -1) {
            orgIds.splice(idIndex, 1);
          }
          const infos = { ...(userInfo.orgInfos || {}) };
          delete infos[this.selectedOrg?.sid];
          const orgId = orgIds.length > 0 ? orgIds[0] : null;
          if (orgId === null) {
            this.triggerLogout();
            this.showMessage('error', this.translate.instant('NO_ACTIVE_ORGANIZATION'));
          } else {
            userInfo.orgIds = orgIds;
            userInfo.orgInfos = infos;
            userInfo.orgId = orgId;
            this.appGlobalService.write('userOrgId', orgId);
            this.appGlobalService.write('orgId', orgId);
            // Update store instead of localStorage
            this.store.dispatch(setUser({ userData: userInfo }));
            this.appGlobalService.write('user', userInfo);
            this.appGlobalService.write('userEmail', userInfo?.email);
            this.routerOrgId = orgId;
            this.store.dispatch(
              getOrgDataForHeader({
                orgApi: ApiConstants.getOrganizationById,
                sid: orgId
              })
            );
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                this.router
                  .navigate(['/home', orgId, 'appId', 'settings', 'appmanagement'], {
                    relativeTo: this.activatedRoute
                  })
                  .catch((error) => console.error(error));
              })
              .catch((error) => console.error(error));
          }
        } catch (e) {
          console.log(e);
        }
      }
    });
    this.subscriptions.push(delOrDeactiveOrg);
    // Subscribe to get details of the currently selected organization.
    // Note: We only set selectedOrg here. The orgs dropdown list is populated
    // separately by orglistForHeader subscription with proper role-based filtering.
    // Access control for unauthorized org access is enforced at the backend level.
    const orgSub = this.store.select(orgDataForHeader).subscribe((orgDataForHeaderRes: any) => {
      if (orgDataForHeaderRes && !orgDataForHeaderRes?.error) {
        this.selectedOrg = orgDataForHeaderRes;
        this.syncSelectedOrgIntoOrgLists();
        if (orgSub) {
          orgSub.unsubscribe();
        }
      }
      if (orgDataForHeaderRes?.error) {
        this.utilService.showError('error', this.translate.instant('ORGANIZATION_DELETED'));
        return;
      }
    });
    this.subscriptions.push(orgSub);

    if (
      !(this.userRole === 'sysAdmin' || this.userRole === 'devAdmin' || this.userRole === 'devViewer') &&
      this.appGlobalService.get('user').orgPrivilege &&
      this.appGlobalService.get('user').orgPrivilege !== 'Prototype Viewer'
    ) {
      this.store.dispatch(
        UsersAction.getAppForUsers({
          apiConstants: ApiConstants.getAppForUser,
          params
        })
      );
      const userSub = this.store.select(userAppData).subscribe((userAppDataRes: any) => {
        if (userAppDataRes != null) {
          this.userAppData = [
            ...Object.keys(
              Object.fromEntries(Object.entries(userAppDataRes).filter(([key, val]) => val === 'Prototype Viewer'))
            )
          ];
          if (
            !(this.userRole === 'sysAdmin' || this.userRole === 'devAdmin' || this.userRole === 'devViewer') &&
            this.apps.length > 0 &&
            this.userAppData.length > 0
          ) {
            this.apps = [...this.apps.filter((item) => item.name && !this.userAppData.includes(item.name))];
          }
        }
      });
      this.subscriptions.push(userSub);
    }

    this.appGlobalService.write('tabId', new Date().getTime().toString());

    this.activatedRoute.paramMap.subscribe((paramsRes: ParamMap) => {
      this.routerOrgId = paramsRes.get('orgId');
      this.routerAppId = paramsRes.get('appId');

      const isNavigatingToArtifacts = this.router.url.includes('artifacts/overview');
      const shouldRedirectToAppManagement =
        this.routerOrgId &&
        (this.routerOrgId.includes('settings') || !this.routerOrgId.includes('-')) &&
        !isNavigatingToArtifacts;

      // Fix: Exclude URL parsing cases where 'artifacts' is present or logic fails by improperly detecting settings
      if (shouldRedirectToAppManagement) {
        if (user) {
          const orgId = this.appGlobalService.get('user') ? this.appGlobalService.get('user').orgIds[0] : '';
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => {
              this.router
                .navigate(['/home', orgId, 'appId', 'settings', 'appmanagement'], {
                  relativeTo: this.activatedRoute
                })
                .catch((error) => console.error(error));
            })
            .catch((error) => console.error(error));
        } else {
          this.showMessage('error', 'The Rappit Url is incorrect, please try to logout and login');
        }
        // unsubcribe the previous app's get generation subscription if it is navigated back to app management page
        if (this.genStsSubscription) {
          this.genStsSubscription.unsubscribe();
          clearTimeout(ApplifecycleEffects.genStatusTimeout);
        }
      } else if (this.routerAppId && this.routerAppId !== 'appId') {
        if (!(this.menuData && this.menuData.length)) {
          this.store.dispatch(
            getSidBasedApps({
              apiConstants: ApiConstants.getAppById,
              sid: this.routerAppId
            })
          );
        }
      }
      this.handleRouteParamsChange();
    });

    if (this.routerOrgId) {
      // When invalidUrl is true, use the corrected orgId (user's first org) instead of URL's orgId
      const orgId =
        this.appGlobalService.get('invalidUrl') === 'true'
          ? this.appGlobalService.get('orgId')
          : this.selectedOrg?.sid
            ? this.selectedOrg?.sid
            : this.routerOrgId;
      this.store.dispatch(
        getOrgDataForHeader({
          orgApi: ApiConstants.getOrganizationById,
          sid: orgId
        })
      );
    }

    if (this.routerAppId !== 'appId') {
      this.appPage = true;

      this.attachAppId(this.routerAppId);
    } else {
      this.appPage = false;
    }

    this.getCurrentUser();

    this.getAppData();

    this.getOrgList();

    const orgInfoSub = this.store.select(orglistForHeader).subscribe((data: any) => {
      if (!data) {
        return;
      }
      if (data.length === 0) {
        this.headerEmpMsg = true;
        this.headerLoader = false;
      } else {
        if (
          this.userRole === 'sysAdmin' ||
          this.userRole === 'devAdmin' ||
          this.userRole === 'devViewer' ||
          (this.userRole === 'Organization Admin' && this.user.devViewer) ||
          (this.userRole === 'Architect' && this.user.devViewer) ||
          (this.userRole === 'Developer' && this.user.devViewer) ||
          (this.userRole === 'Consultant' && this.user.devViewer) ||
          (this.userRole === 'Viewer' && this.user.devViewer) ||
          (this.userRole === 'Prototype Viewer' && this.user.devViewer)
        ) {
          this.orgs = data;
        } else {
          this.orgs = data.filter((org) => this.user.orgIds.includes(org.sid));
        }
        if (!this.searchTextOrg) {
          this.userOrgs = [...this.orgs];
        }
        const org: any = this.orgs.find((e) => e.sid === this.selectedOrg?.sid);
        if (!org) {
          this.orgs = [...this.orgs, this.selectedOrg];
          this.userOrgs = [...this.orgs];
          this.headerLoader = false;
        }
        if (!this.selectedOrg) {
          const orgId =
            this.appGlobalService.get('invalidUrl') === 'true' ? this.appGlobalService.get('orgId') : this.routerOrgId;
          this.selectedOrg = this.orgs.find((orgn) => orgn.sid === orgId);
        }
      }
    });
    this.subscriptions.push(orgInfoSub);

    this.eventTracker.start('appSettingsData');

    const appSettSub = this.store.select(appSettingsData).subscribe((val) => {
      console.log(`appSettingsData : ${this.eventTracker.trackedEvents.appSettingsData.duration}`);
      if (val) {
        this.appGlobalService.write('technologySettings', val);
      }
    });
    this.subscriptions.push(appSettSub);
    const userDataSub = this.store.select(userData).subscribe((userDataRes: any) => {
      if (userDataRes) {
        this.user = userDataRes;
        this.getUserRole();
        this.debounceGetDefaultBranches();
        if (!this.userDocListener) {
          this.attachUserDocumentListener();
        }
      }
    });
    if (
      this.user.devViewer &&
      this.userRole !== 'Organization Admin' &&
      (this.userRole !== 'Developer' || this.userRole !== 'Architect')
    ) {
      this.showPublish = false;
    }

    if (
      !(this.userRole === 'sysAdmin' || this.userRole === 'devAdmin' || this.userRole === 'devViewer') &&
      this.appGlobalService.get('user').orgPrivilege &&
      this.appGlobalService.get('user').orgPrivilege !== 'Prototype Viewer'
    ) {
      this.store.dispatch(
        UsersAction.getAppForUsers({
          apiConstants: ApiConstants.getAppForUser,
          params
        })
      );
      const userSub = this.store.select(userAppData).subscribe((userAppDataRes: any) => {
        if (userAppDataRes != null) {
          this.userAppData = [
            ...Object.keys(
              Object.fromEntries(Object.entries(userAppDataRes).filter(([key, val]) => val === 'Prototype Viewer'))
            )
          ];
          if (
            !(this.userRole === 'sysAdmin' || this.userRole === 'devAdmin' || this.userRole === 'devViewer') &&
            this.apps.length > 0 &&
            this.userAppData.length > 0
          ) {
            this.apps = [...this.apps.filter((item) => item.name && !this.userAppData.includes(item.name))];
          }
        }
      });
      this.subscriptions.push(userSub);
    }

    const sidebarSub = this.store.select(menuData).subscribe((menu) => {
      this.menuData = menu;
    });
    this.subscriptions.push(sidebarSub);

    // Action will be dispatched from jexcel-sheet-roles-acl component
    const toggleSideBarSub = this.store.select(toggleSideBar).subscribe((toggleState) => {
      if (toggleState.lastToggledTime) {
        this.handleHamburgerClick();
      }
    });
    this.subscriptions.push(toggleSideBarSub);

    const openFormSubscripton = this.store.select(appData).subscribe((appDataRes: any) => {
      if (!this.appGlobalService.get('appName')) {
        this.appGlobalService.write('appName', appDataRes?.name);
      }
      if (appDataRes.projectMenu) {
        this.store.dispatch(setMenuData({ menuData: appDataRes?.projectMenu?.menuItems }));
      }
    });
    this.subscriptions.push(openFormSubscripton);

    const chatCollapsedSub = this.headerService.isChatCollapsed$.subscribe((collapsed) => {
      this.isChatCollapsed = collapsed;
    });
    this.subscriptions.push(chatCollapsedSub);

    const sessionsPanelSub = this.headerService.isSessionsPanelOpen$.subscribe((isOpen) => {
      this.isSessionsPanelOpen = isOpen;
    });
    this.subscriptions.push(sessionsPanelSub);

    const newSessionSub = this.headerService.isNewSessionActive$.subscribe((isActive) => {
      this.isNewSessionActive = isActive;
    });
    this.subscriptions.push(newSessionSub);

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.currentUrl = event.urlAfterRedirects;

      if (this.userMenu) {
        this.userMenu.hide();
      }

      if (this.currentUrl.includes('/settings/appmanagement')) {
        this.debounceGetDefaultBranches();
      }

      const appId = this.appGlobalService.get('appId');
      if (appId !== this.lastUsedAppIdForFsSignIn) {
        this.resetMaintenanceStatus();
        this.signInAndGetFsData().catch((error) => console.error(error));
      }
      this.showHideMaintenancePopup();

      // Re-subscribe to merge status when navigating to an app page
      // This handles the case when user navigates away and comes back to the same app
      if (appId && appId !== 'appId') {
        this.mergeStatusService.subscribeToMergeStatus(appId);
      }
    });
  }

  onClick(event: any) {
    // Intentionally left empty
  }
  closeDropDown() {
    this.dropdownEle1.hide();
  }
  ngAfterViewInit() {
    const _this = this;
    $(document).on('keyup.enter', '.app-header__content.p-select-filter', function (event) {
      if (event.which === 13) {
        _this.dropdownEle.show();
      }
    });
  }

  setMaintenance(res) {
    const currentAppId = this.appGlobalService.get('appId');
    let generationStatus;
    let appCopyMaintenanceStatus;
    let referenceFrameworkMaintenanceStatus;
    let branchMaintenanceStatus;

    for (const dt of res) {
      const doc = dt.payload.doc;
      const rec = doc.data();

      // Skip cached or deleted records
      if (doc.metadata.fromCache || rec.recDeleted) {
        continue;
      }

      this.appcopy = false;
      generationStatus = rec.generationStatus;
      appCopyMaintenanceStatus = rec.appCopyMaintenanceStatus;
      referenceFrameworkMaintenanceStatus = rec.referenceFrameworkMaintenanceStatus;
      branchMaintenanceStatus = rec.branchMaintenanceStatus;
      if (rec.appId === currentAppId) {
        this.currentBranchStatus = branchMaintenanceStatus;
      }
      if (rec.appId === currentAppId) {
        this.currentBranchStatus = branchMaintenanceStatus;
      }


      this.setAppCopyMaintenance(appCopyMaintenanceStatus, rec);
      if (['APPCOPY_STARTED', 'UNDER_VALIDATION', 'VALIDATION_FAILED'].includes(appCopyMaintenanceStatus)) {
        break;
      }

      this.setGenerationStatusMaintenance(generationStatus, rec);
      if (['MAINTENANCE_STARTED', 'METAINFO_READING_STARTED', 'ROLE_COPY_STARTED', 'BUILD_STARTED'].includes(generationStatus)) {
        break;
      }

      this.setReferenceFrameworkMaintenance(referenceFrameworkMaintenanceStatus, rec);
      if (
        ['REFERENCE_VALIDATION_STARTED', 'REFERENCE_CREATION_STARTED'].includes(referenceFrameworkMaintenanceStatus)
      ) {
        break;
      }
    }
    if (appCopyMaintenanceStatus) {
      this.showHideMaintenancePopup(appCopyMaintenanceStatus);
    }
    if (referenceFrameworkMaintenanceStatus) {
      this.showHideMaintenancePopup(referenceFrameworkMaintenanceStatus);
    }
    if (generationStatus) {
      this.showHideMaintenancePopup(generationStatus);
    }
    if (branchMaintenanceStatus) {
      this.showHideMaintenancePopup(branchMaintenanceStatus);
    }
  }

  setGenerationStatusMaintenance(status: string, rec: any) {
    const appId = rec.appId;
    switch (status) {
      case 'MAINTENANCE_STARTED':
        this.appGlobalService.write('maintananceStatus', 'started');
        this.maintenance = ['ALL', ''].includes(appId);
        this.appSpecificMaintenance = true;
        break;
      case 'MAINTENANCE_COMPLETED':
        this.appGlobalService.write('maintananceStatus', 'completed');
        if (['ALL', ''].includes(appId)) {
          this.maintenance = false;
        } else {
          this.appSpecificMaintenance = false;
        }
        break;
      case 'METAINFO_READING_STARTED':
        this.appGlobalService.write('metaInfoReadingStatus', 'started');
        this.maintenance = appId === 'ALL';
        this.appSpecificMaintenance = true;
        break;
      case 'METAINFO_READING_COMPLETED':
        this.appGlobalService.write('metaInfoReadingStatus', 'completed');
        this.maintenance = false;
        this.appSpecificMaintenance = false;
        break;
      case 'ROLE_COPY_STARTED':
        this.appGlobalService.write('maintananceStatus', 'started');
        this.appSpecificMaintenance = true;
        this.blockerType = 'BULK_ACL';
        this.blockerData = {
          initiatedBy: this.appGlobalService.get('appmetaInfo')[rec.modifiedBy] || 'an user'
        };
        break;
      case 'ROLE_COPY_COMPLETED':
        this.appGlobalService.write('maintananceStatus', 'completed');
        this.appSpecificMaintenance = false;
        this.blockerType = '';
        this.blockerData = {};
        // Show the success message only when status transitions from ROLE_COPY_STARTED
        if (this.previousGenerationStatus === 'ROLE_COPY_STARTED') {
          const modifiedDataTime = new Date(rec?.modifiedDate?.seconds * 1000 + rec?.modifiedDate?.nanoseconds / 1e6);
          const currentDateTime = new Date();
          const timeDiff = (currentDateTime.getTime() - modifiedDataTime.getTime()) / 1000;
          if (timeDiff > 0 && timeDiff <= 5) {
            this.utilService.showSuccess(this.translate.instant('ROLE_ACCESS_COPY_COMPLETED'));
          }
        }
        break;
      case 'BUILD_STARTED':
        this.appGlobalService.write('maintananceStatus', 'started');
        this.appSpecificMaintenance = true;
        this.blockerType = 'VIBE_BUILD';
        this.blockerData = {
          initiatedBy: this.appGlobalService.get('appmetaInfo')[rec.modifiedBy] || 'an user'
        };
        break;
      case 'BUILD_COMPLETED':
        this.appGlobalService.write('maintananceStatus', 'completed');
        this.appSpecificMaintenance = false;
        this.blockerType = '';
        this.blockerData = {};
        // Show the success message only when status transitions from BUILD_STARTED
        if (this.previousGenerationStatus === 'BUILD_STARTED') {
          const modifiedDataTime = new Date(rec?.modifiedDate?.seconds * 1000 + rec?.modifiedDate?.nanoseconds / 1e6);
          const currentDateTime = new Date();
          const timeDiff = (currentDateTime.getTime() - modifiedDataTime.getTime()) / 1000;
          if (timeDiff > 0 && timeDiff <= 5) {
            this.utilService.showSuccess(this.translate.instant('BUILD_ARTIFACTS_COMPLETED'));
          }
        }
        break;
      default:
        break;
    }
    this.previousGenerationStatus = status;
  }

  setAppCopyMaintenance(status: string, rec: any) {
    switch (status) {
      case 'APPCOPY_STARTED':
      case 'UNDER_VALIDATION':
      case 'VALIDATION_FAILED':
        this.appGlobalService.write('appcopyStatus', 'started');
        const metaInfo = this.appGlobalService.get('appmetaInfo');
        this.appcopyModifiedBy = metaInfo[rec.modifiedBy] || rec.modifiedBy;
        this.appcopyModifiedDate = this.utilService.formatModifiedDateTimestamp(rec.modifiedDate);
        this.maintenance = false;
        this.appcopy = true;
        break;
      case 'APPCOPY_COMPLETED':
        this.appGlobalService.write('appcopyStatus', 'completed');
        this.maintenance = false;
        this.appcopy = false;
        break;
    }
  }

  setReferenceFrameworkMaintenance(status: string, rec: any) {
    switch (status) {
      case 'REFERENCE_VALIDATION_STARTED':
        this.maintenance = false;
        this.referenceMaintenance = true;
        this.appGlobalService.write('referenceValidationStatus', 'started');
        break;
      case 'REFERENCE_CREATION_STARTED':
        this.maintenance = false;
        this.referenceMaintenance = true;
        this.appGlobalService.write('referenceCreationStatus', 'started');
        break;
      case 'REFERENCE_VALIDATION_COMPLETED':
        this.maintenance = false;
        this.referenceMaintenance = false;
        this.appGlobalService.write('referenceValidationStatus', 'completed');
        break;
      case 'REFERENCE_CREATION_COMPLETED':
        this.maintenance = false;
        this.referenceMaintenance = false;
        this.appGlobalService.write('referenceCreationStatus', 'completed');
        break;
    }
  }

  branchMaintenance = false;
  setBranchMaintenanceStatus(status: string) {
    switch (status) {
      case 'BRANCH_CREATION_IN_PROGRESS':
      case 'SUITE_BRANCH_CREATION_IN_PROGRESS':
      case 'BRANCH_VALIDATION_IN_PROGRESS':
      case 'BRANCH_CREATION_FAILED':
        this.branchMaintenance = true;
        this.appGlobalService.write('branchCreationStatus', 'started');
        break;
      case 'TAG_CREATION_IN_PROGRESS':
      case 'SUITE_TAG_CREATION_IN_PROGRESS':
      case 'TAG_VALIDATION_IN_PROGRESS':
      case 'TAG_CREATION_FAILED':
        this.branchMaintenance = true;
        this.appGlobalService.write('tagCreationStatus', 'started');
        break;
      case 'BRANCH_CREATION_COMPLETED':
      case 'SUITE_BRANCH_CREATION_COMPLETED':
        this.branchMaintenance = false;
        this.appGlobalService.write('branchCreationStatus', 'completed');
        break;
      case 'TAG_CREATION_COMPLETED':
      case 'SUITE_TAG_CREATION_COMPLETED':
        this.branchMaintenance = false;
        this.appGlobalService.write('tagCreationStatus', 'completed');
        break;
    }
  }
  resetMaintenanceStatus() {
    if (!this.config.flags.isApp_MergeStatus_InProgress) {
      this.maintenance = false;
      this.appSpecificMaintenance = false;
      this.referenceMaintenance = false;
      this.appcopy = false;
      this.branchMaintenance = false;
      this.appGlobalService.write('maintananceStatus', 'completed');
      this.appGlobalService.write('metaInfoReadingStatus', 'completed');
      this.appGlobalService.write('referenceValidationStatus', 'completed');
      this.appGlobalService.write('referenceCreationStatus', 'completed');
      this.appGlobalService.write('appcopyStatus', 'completed');
      this.appGlobalService.write('branchCreationStatus', 'completed');
      this.appGlobalService.write('tagCreationStatus', 'completed');
      this.appGlobalService.write('branchCreationStatus', 'completed');
      this.appGlobalService.write('tagCreationStatus', 'completed');
    }
  }

  showHideMaintenancePopup(status?: string) {
    if (!this.config.flags.isApp_MergeStatus_InProgress) {
      const appId = this.appGlobalService.get('appId');
      const isGlobalMaintenance = ['ALL', ''].includes(appId) ? this.maintenance : this.appSpecificMaintenance;

      if (isGlobalMaintenance) {
        this.blockedMessage = this.translate.instant('APPLICATION_IN_MAINTANENCE');

        if (this.appGlobalService.get('metaInfoReadingStatus') === 'started') {
          this.blockedMessage = this.translate.instant('APPLICATION_GENERATION');
          setTimeout(() => {
            if (this.appGlobalService.get('metaInfoReadingStatus') === 'completed') {
              this.blockedDocument = false;
            } else {
              this.notifyingUser = true;
              this.blockedDocument = true;
              const interval = setInterval(() => {
                if (this.appGlobalService.get('metaInfoReadingStatus') === 'completed') {
                  setTimeout(() => {
                    this.notifyingUser = false;
                    this.blockedDocument = false;
                  }, 3000);
                  clearInterval(interval);
                }
              }, 500);
            }
          }, 3000);
        }
        if (this.appGlobalService.get('maintananceStatus') === 'started') {
          this.blockedDocument = true;
        }
        return;
      }

      if (this.appcopy && this.currentPage != 'settings' && this.currentPage != 'dashboards') {
        this.blockedMessage = `${
          status === 'APPCOPY_STARTED'
            ? this.translate.instant('APPLICATION_COPY_IN_PROGRESS')
            : status == 'UNDER_VALIDATION'
              ? this.translate.instant('UNDER_VALIDATION')
              : this.translate.instant('VALIDATION_FAILED')
        }<br> ${this.translate.instant('LAST_MODIFIED_BY')}: ${this.appcopyModifiedBy} ${this.translate.instant('ON')} ${this.appcopyModifiedDate}`;
        if (this.appGlobalService.get('appcopyStatus') === 'started') {
          this.blockedDocument = true;
        }
        return;
      }

      if (this.referenceMaintenance) {
        if (status === 'REFERENCE_VALIDATION_STARTED') {
          this.blockedMessage = this.translate.instant('REFERENCE_VALIDATION_IN_PROGRESS');
        } else if (status === 'REFERENCE_CREATION_STARTED') {
          this.blockedMessage = this.translate.instant('REFERENCE_CREATION_IN_PROGRESS');
        }
        if (
          this.appGlobalService.get('referenceValidationStatus') === 'started' ||
          this.appGlobalService.get('referenceCreationStatus') === 'started'
        ) {
          this.blockedDocument = true;
        }
        return;
      }

    if (this.branchMaintenance) {
      if (status === 'BRANCH_CREATION_IN_PROGRESS' || status === 'SUITE_BRANCH_CREATION_IN_PROGRESS') {
        this.blockedMessage = this.translate.instant('BRANCH_CREATION_IN_PROGRESS');
      } else if (status === 'BRANCH_VALIDATION_IN_PROGRESS') {
        this.blockedMessage = this.translate.instant('BRANCH_VALIDATION_IN_PROGRESS');
      } else if (status === 'TAG_CREATION_IN_PROGRESS' || status === 'SUITE_TAG_CREATION_IN_PROGRESS') {
        this.blockedMessage = this.translate.instant('TAG_CREATION_IN_PROGRESS');
      } else if (status === 'TAG_VALIDATION_IN_PROGRESS') {
        this.blockedMessage = this.translate.instant('TAG_VALIDATION_IN_PROGRESS');
      }

      if (
        this.appGlobalService.get('branchCreationStatus') === 'started' ||
        this.appGlobalService.get('tagCreationStatus') === 'started'
      ) {
        this.blockedDocument = true;
      }
      return;
    }

      if (this.notifyingUser) {
        return;
      }

      if (!appId && this.appSpecificMaintenance) {
        this.blockedDocument = false;
        this.appGlobalService.write('maintananceStatus', 'completed');
        this.maintenance = false;
        this.appSpecificMaintenance = false;
        return;
      }

      setTimeout(() => {
        this.blockedDocument = false;
        this.appGlobalService.write('maintananceStatus', 'completed');
        this.maintenance = false;
        this.appSpecificMaintenance = false;
      }, 2000);
    }
  }

  maintainAppEditablity(status: string, appId: string) {
    if (appId === '' || appId === 'ALL') {
      return;
    }
    if (this.mergeStatusInfo?.isMergeInProgress) {
      return;
    }

    if (
      !this.targetBranchCreationInProgress &&
      this.utilService.completedStatus.includes(status)
    ) {
      return;
    }
    this.utilService.setBranchMaintenanceStatus(status);
    if (this.utilService.blockedStatus.includes(status)) {
      this.targetBranchCreationInProgress = true;
    } else {
      this.targetBranchCreationInProgress = false;
    }
  }

  getMsAppIds(appId: any): Promise<any[]> {
    return new Promise((resolve) => {
      const appIdList: any[] = [];
      this.store.dispatch(
        getMemApps({
          apiConstants: ApiConstants.getMemAppsBySuite,
          params: {
            suiteid: this.appGlobalService.get('suiteId')
          }
        })
      );
      const memAppSub = this.store.select(memAppList).subscribe((memAppsDataRes: any) => {
        if (memAppsDataRes && memAppsDataRes.length > 0) {
          memAppsDataRes.forEach((memApp) => {
            if (!appIdList.includes(memApp.sid) && memApp.sid != appId) {
              appIdList.push(memApp.sid);
            }
          });
          resolve(appIdList);
        } else if (memAppsDataRes && memAppsDataRes.length == 0) {
          resolve(appIdList);
        }
      });
      this.subscriptions.push(memAppSub);
    });
  }

  async attachAppInfoListner() {
    const version = this.appGlobalService.get('appVersion');
    const orgId = this.appGlobalService.get('orgId');
    const appId = this.appGlobalService.get('appId');
    const hasValidAppId = appId && appId !== 'appId';
    const initialFetchStartTime = new Date();

    if (!orgId) {
      return;
    }

    try {
      const appIdList: any[] = [];
      appIdList.push(appId);
      if(appId){
        if (this.appGlobalService.get('applicationType') != ApplicationTypes.INDEPENDENT) {
          if (this.appGlobalService.get('applicationType') == ApplicationTypes.MEMBER) {
            appIdList.push(this.appGlobalService.get('suiteId'));
          }
          const msAppIds = await this.getMsAppIds(appId);
          appIdList.push(...msAppIds);
        }
      }
      await this.fetchInitialMetaInfo();

      // AppUserMetaInfo Firestore listener: org-level, always set up
      const appUserMetaInfoQueryObj = {
        collectionName: `AppUserMetaInfo`,
        filter: [
          { field: 'orgIds', operator: 'array-contains', value: orgId },
          { field: 'recDeleted', operator: '==', value: false },
          { field: 'modifiedDate', operator: '>=', value: initialFetchStartTime }
        ]
      };
      this.getUpdatedMetaInfoData(appUserMetaInfoQueryObj, 'APP_USER_META_INFO', null);

      // AppMetaInfo Firestore listener: app-level, only when an app is selected
      if (hasValidAppId) {
        const appIdList: any[] = [];
        appIdList.push(appId);
        if (this.appGlobalService.get('applicationType') != ApplicationTypes.INDEPENDENT) {
          if (this.appGlobalService.get('applicationType') == ApplicationTypes.MEMBER) {
            appIdList.push(this.appGlobalService.get('suiteId'));
          }
          const msAppIds = await this.getMsAppIds(appId);
          appIdList.push(...msAppIds);
        }

        const appMetaInfoQueryObj = {
          collectionName: `AppMetaInfo_${version}`,
          filter: [
            { field: 'appId', operator: 'in', value: appIdList },
            { field: 'recDeleted', operator: '==', value: false },
            { field: 'modifiedDate', operator: '>=', value: initialFetchStartTime }
          ]
        };
        this.getUpdatedMetaInfoData(appMetaInfoQueryObj, 'APP_META_INFO', null);
      }
    } catch (e) {
      console.error(e);
    }
  }

  eventTracker: any = {
    trackedEvents: {} as Record<string, any>,

    start: (key) => {
      const startTime = new Date();
      this.eventTracker.trackedEvents[key] = {
        start: startTime
      };
    },

    stop: (key) => {
      const endTime: any = new Date();
      this.eventTracker.trackedEvents[key].duration =
        `${this.utilService.formatDateForConsole(this.eventTracker.trackedEvents[key].start)} ${this.utilService.formatDateForConsole(endTime)}  ===> ${(endTime - this.eventTracker.trackedEvents[key].start) / 1000}s`;
      this.eventTracker.trackedEvents[key].end = endTime;
    }
  };

  signInAndGetFsData(): Promise<void> {
    const appId = this.appGlobalService.get('appId');
    this.lastUsedAppIdForFsSignIn = appId;
    this.unSubscribeListener();
    this.store.dispatch(setFsLoginInitiated({ loggedIn: false }));
    return new Promise<void>((resolve, reject) => {
      const fsDataSub = this.baseService.get(ApiConstants.getFstoken).subscribe(
        (token: string) => {
          this.angularFireAuth.signInWithCustomToken(token).then(
            (data: any) => {
              this.store.dispatch(setFsLoginInitiated({ loggedIn: true }));
                this.appGlobalService.write('queryStrings', {});
                this.attachAppInfoListner();
                // Attach listener for shared access and branch/app deletion
                if (['', 'appId'].indexOf(this.routerAppId) === -1) {
                  this.attachSharedAccessListener();
                } else {
                  // On lifecycle/app management page, listen to all apps in the org
                  this.attachAllAppsListener();
                }
              this.fetchMaintenanceStatus();
              this.fetchBranchingStatus();
              resolve();
            },
            (error: any) => {
              console.error(error);
              reject();
            }
          );
        },
        (err) => {
          reject();
        }
      );
      this.attachAppInfoListnerSubscription.push(fsDataSub);
    });
  }

  gettechStackData() {
    let techsub;
    if (this.applicationType !== ApplicationTypes.INDEPENDENT) {
      techsub = this.baseService
        .get(ApiConstants.getTechnologyStackBySuiteId, {
          suiteid: this.suiteId,
          shareddbid: this.sharedDbId
        })
        .subscribe((techStackData: any) => {
          this.appGlobalService.write('technologyChoices', techStackData);
          if (techsub) {
            techsub.unsubscribe();
          }
        });
    } else {
      const apiConstants = { ...ApiConstants.getTechnologyStackById };
      apiConstants.url = apiConstants.url + this.appGlobalService.get('appId');
      techsub = this.baseService[apiConstants.method](apiConstants).subscribe((techStackData) => {
        this.appGlobalService.write('technologyChoices', techStackData);
        if (techsub) {
          techsub.unsubscribe();
        }
      });
    }
    this.subscriptions.push(techsub);
  }

  private async fetchInitialMetaInfo() {
    const batchSize = GlobalConstants.apiCallBatchSize;
    const appId = this.appGlobalService.get('appId');
    const hasValidAppId = appId && appId !== 'appId';

    let appMetaInfoCountSubsObservable: Observable<any>;
    if (hasValidAppId) {
      appMetaInfoCountSubsObservable = this.baseService.get(ApiConstants.getAppMetaInfoCount, { appId: appId });
    } else {
      appMetaInfoCountSubsObservable = of(0);
    }

    try {
      const metaInfoCountSubs$ = {
        appMetaInfoCount: appMetaInfoCountSubsObservable,
        appUserMetaInfoCount: this.baseService.get(ApiConstants.getAppUserMetaInfoCount, {
          orgId: this.appGlobalService.get('orgId')
        })
      };

      const { appMetaInfoCount, appUserMetaInfoCount } = await firstValueFrom(forkJoin(metaInfoCountSubs$));

      const appMetaInfoFetchSubs$: Observable<any>[] = [];
      for (let i = 0; i < Math.ceil(parseInt(appMetaInfoCount as string) / batchSize); i++) {
        appMetaInfoFetchSubs$.push(
          this.baseService.post(ApiConstants.getAppMetaInfo, {
            start: i * batchSize,
            length: batchSize
          })
        );
      }

      const appUserMetaInfoFetchSubs$: Observable<any>[] = [];
      for (let j = 0; j < Math.ceil(parseInt(appUserMetaInfoCount as string) / batchSize); j++) {
        appUserMetaInfoFetchSubs$.push(
          this.baseService.post(ApiConstants.getAppUserMetaInfo, {
            start: j * batchSize,
            length: batchSize
          })
        );
      }

      let appMetaInfoResponses: any[] = [];
      if (appMetaInfoFetchSubs$.length > 0) {
        appMetaInfoResponses = await firstValueFrom(forkJoin(appMetaInfoFetchSubs$));
      }

      let appUserMetaInfoResponses: any[] = [];
      if (appUserMetaInfoFetchSubs$.length > 0) {
        appUserMetaInfoResponses = await firstValueFrom(forkJoin(appUserMetaInfoFetchSubs$));
      }

      const metaInfoFromStore = JSON.parse(JSON.stringify(this.appGlobalService.get('appmetaInfo'))) || {};
      const queryStrings = JSON.parse(JSON.stringify(this.appGlobalService.get('queryStrings'))) || {};
      const refMetaInfoFromStore = JSON.parse(JSON.stringify(this.appGlobalService.get('refAppMetaInfos'))) || {};
      appMetaInfoResponses.forEach((res: any) => {
        res.results.forEach((rec) => {
          metaInfoFromStore[rec.modelId] = rec.name;
          if (rec.modelType === 'QUERY_STRING') {
            queryStrings[rec.modelId] = rec.name;
          }
          if (rec.appId != this.appGlobalService.get('appId')) {
            refMetaInfoFromStore[rec.modelId] = rec.name;
          }
        });
      });

      appUserMetaInfoResponses.forEach((res: any) => {
        res.results.forEach((rec) => {
          metaInfoFromStore[rec.modelId] = rec.name;
        });
      });

      this.appGlobalService.write('appmetaInfo', metaInfoFromStore);
      this.appGlobalService.write('queryStrings', queryStrings);
      this.appGlobalService.write('refAppMetaInfos', refMetaInfoFromStore);

      this.store.dispatch(setAppMetaInfo({ metaInfo: metaInfoFromStore }));
    } catch (error) {
      console.error('Error fetching initial meta info:', error);
    }
  }

  private getUpdatedMetaInfoData(queryObject: any, type: 'APP_META_INFO' | 'APP_USER_META_INFO', lastVisible?) {
    this.eventTracker.start('AppMetaInfo');
    queryObject.orderBy = 'modifiedDate';
    queryObject.limit = 1000;
    if (lastVisible) {
      queryObject.startafter = lastVisible;
    }
    const fsSub1 = this.fsBaseService.fireService(queryObject).subscribe(
      (res: any) => {
        this.eventTracker.stop('AppMetaInfo');
        console.log(`AppMetaInfo: ${this.eventTracker.trackedEvents.AppMetaInfo.duration}`);
        const lastVisible1 = res[res.length - 1];
        if (res.length === 1000 && lastVisible1.type === 'added') {
          const lastVisible2 = res[res.length - 1];
          console.log(lastVisible2.payload.doc.data().sid);
          this.eventTracker.stop('AppMetaInfo');
          this.getUpdatedMetaInfoData(queryObject, type, lastVisible2.payload.doc);
        } else {
          if (type === 'APP_META_INFO') {
            this.appGlobalService.write(GlobalConstants.isAppMetaInfoPopulated, true);
          }
          if (type === 'APP_USER_META_INFO') {
            this.appGlobalService.write(GlobalConstants.isAppUserMetaInfoPopulated, true);
          }
        }
        const d = JSON.parse(JSON.stringify(this.appGlobalService.get('appmetaInfo'))) || {};
        const refAppMetaInfo = JSON.parse(JSON.stringify(this.appGlobalService.get('refAppMetaInfos'))) || {};
        const queryStrings = JSON.parse(JSON.stringify(this.appGlobalService.get('queryStrings'))) || {};
        let queryStringsUpdated = false;

        if (res) {
          res.forEach((dt: any) => {
            const rec = dt.payload.doc.data();
            const isQueryString = rec.modelType === 'QUERY_STRING';
            const changeType = dt?.type; // 'added', 'modified', or 'removed'
            const isRefAppMetaInfo = rec.appId !== this.appGlobalService.get('appId');
            if (changeType === 'removed') {
              // Handle removed records
              console.log('Updating queryStrings in removed', queryStrings);
              delete d[rec.modelId];
              if (isQueryString) {
                delete queryStrings[rec.modelId];
                queryStringsUpdated = true;
              }
              if (isRefAppMetaInfo) {
                delete refAppMetaInfo[rec.modelId];
              }
              console.log('Updating queryStrings in after removed', queryStrings);
            } else if (changeType === 'added' || changeType === 'modified') {
              // Handle added and modified records
              d[rec.modelId] = rec.name;
              if (isQueryString) {
                queryStrings[rec.modelId] = rec.name;
                queryStringsUpdated = true;
              }
              if (isRefAppMetaInfo) {
                refAppMetaInfo[rec.modelId] = rec.name;
              }
            }
          });
        }

        this.appGlobalService.write('appmetaInfo', d);
        this.store.dispatch(setAppMetaInfo({ metaInfo: d }));
        this.appGlobalService.write('refAppMetaInfos', refAppMetaInfo);
        // Always update queryStrings in appGlobalService when there are changes
        if (queryStringsUpdated) {
          console.log('Updating queryStrings in appGlobalService', queryStrings);
          this.appGlobalService.write('queryStrings', queryStrings);
        }
      },
      (error) => {
        console.error(error);
      }
    );
    this.attachAppInfoListnerSubscription.push(fsSub1);
  }

  dispatchMenuCollapsedEvent() {
    this.store.dispatch(
      menuActions.clickHamburger({
        collapsedMenu: this.isMenuCollapsed
      })
    );
  }

  toggleRaiMode() {
    this.raiModeEnabledForUser = !this.raiModeEnabledForUser;

    this.baseService
      .put(ApiConstants.toggleRaiModeForCurrentUser, {
        raiModeEnabled: this.raiModeEnabledForUser
      })
      .subscribe({
        next: () => {
          window.location.reload();
        },
        error: (err) => {
          console.error('Failed to toggle RAI mode', err);
          // Revert the local value if API fails
          this.raiModeEnabledForUser = !this.raiModeEnabledForUser;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update RAI mode. Please try again.'
          });
        }
      });
  }

  toggleRaiModeForApp() {
    this.raiModeEnabledForApp = !this.raiModeEnabledForApp;

    this.appGlobalService.updateRaiModeEnabledForApp(this.raiModeEnabledForApp);

    const orgId = this.appGlobalService.get('orgId');
    const appId = this.appGlobalService.get('appId');

    let routes: any = [];

    if (this.raiModeEnabledForApp) {
      routes = ['prototyping', 'preview'];
    } else {
      routes = ['gathering', 'documents'];
    }

    this.router.navigate(['/home', orgId, appId, ...routes]).then(() => {
      window.location.reload();
    });
  }

  updateUserKebabMenu() {
    this.userMenuItems = [];

    const currentRouterURL = this.router.url;

    const currentPath = this.activatedRoute.snapshot.firstChild?.routeConfig?.path;
    const isAppManagementRoute =
      currentPath === 'appmanagement' || currentPath === 'settings' || currentPath === 'dashboards';

    if (isAppManagementRoute) {
      this.menuJSON?.forEach((menuItem: any) => {
        // NOTE - Sequence is defined by how menuJSON already constructed. Not, if/else sequence exist below
        if (menuItem.scenario === 'VIEW_ORG') {
          this.userMenuItems.push({
            label: this.translate.instant('VIEW_ORG'),
            icon: menuItem.iconClass || 'pi pi-building',
            styleClass: currentRouterURL.includes('/getOrgDetail') ? 'active-menu-item' : '',
            command: () => {
              const orgId = this.appGlobalService.get('orgId');
              if (orgId) {
                this.router.navigate(['/home', orgId, 'appId', 'settings', 'getOrgDetail']);
              }
            }
          });
        } else if (menuItem.scenario === 'USER_MANAGEMENT') {
          this.userMenuItems.push({
            label: this.translate.instant('MANAGE_USERS'),
            icon: menuItem.iconClass || 'pi pi-users',
            styleClass: currentRouterURL.includes('/manageusers') ? 'active-menu-item' : '',
            command: () => {
              const orgId = this.appGlobalService.get('orgId');
              this.router.navigate(['/home', orgId, 'appId', 'settings', 'manageusers']);
            }
          });
        } else if (menuItem.scenario === 'ORG_LIST') {
          this.userMenuItems.push({
            label: this.translate.instant('ORG_LIST'),
            icon: menuItem.iconClass || 'pi pi-address-book',
            styleClass: currentRouterURL.includes('/manageorgs') ? 'active-menu-item' : '',
            command: () => {
              const orgId = this.appGlobalService.get('orgId');
              this.router.navigate(['/home', orgId, 'appId', 'settings', 'manageorgs']);
            }
          });
        } else if (menuItem.scenario === 'APP_MANAGEMENT') {
          this.userMenuItems.push({
            label: this.translate.instant('APP_MANAGEMENT'),
            icon: menuItem.iconClass || 'pi pi-th-large',
            styleClass: currentRouterURL.includes('/appmanagement') ? 'active-menu-item' : '',
            command: () => {
              const orgId = this.appGlobalService.get('orgId');
              this.router.navigate(['/home', orgId, 'appId', 'settings', 'appmanagement']);
            }
          });
        }
      });

      this.userMenuItems.push({ separator: true });

      this.userMenuItems.push({
        label: this.translate.instant('CLOUDS_CENTER'),
        icon: 'cloud',
        styleClass: currentRouterURL.includes('/dashboards/clouds-centre')
          ? 'active-menu-item custom-icon-menu-item'
          : 'custom-icon-menu-item',
        command: () => {
          const orgId = this.appGlobalService.get('orgId');
          this.router.navigate(['/home', orgId, 'appId', 'dashboards', 'clouds-centre']);
        }
      });

      this.userMenuItems.push({
        label: this.translate.instant('BILLING_AND_LICENSING'),
        icon: 'billing-home',
        styleClass: currentRouterURL.includes('/dashboards/billing-home')
          ? 'active-menu-item custom-icon-menu-item'
          : 'custom-icon-menu-item',
        command: () => {
          const orgId = this.appGlobalService.get('orgId');
          this.router.navigate(['/home', orgId, 'appId', 'dashboards', 'billing-home']);
        }
      });

      this.userMenuItems.push({
        label: this.translate.instant('ENV_AVAIL_MENU_LABEL'),
        icon: 'pi pi-server',
        styleClass: currentRouterURL.includes('/settings/environment-availability') ? 'active-menu-item' : '',
        command: () => {
          const orgId = this.appGlobalService.get('orgId');
          this.router.navigate(['/home', orgId, 'appId', 'settings', 'environment-availability']);
        }
      });

      this.userMenuItems.push({ separator: true });

      this.userMenuItems.push({
        label: this.translate.instant('BUILT_WITH_VIBE_MODE'),
        icon: this.raiModeEnabledForUser ? 'fa fa-toggle-on text-primary' : 'fa fa-toggle-off',
        styleClass: 'rai-toggle-menu-item',
        command: () => {
          this.toggleRaiMode();
        }
      });

      this.userMenuItems.push({
        label: this.translate.instant('LOGOUT'),
        icon: 'pi pi-sign-out',
        styleClass: 'logout-menu-item',
        command: () => {
          this.triggerLogout();
        }
      });
    } else {
      this.userMenuItems.push({
        label: this.translate.instant('SHOW_AS_VIBE_MODE'),
        icon: this.raiModeEnabledForApp ? 'fa fa-toggle-on text-primary' : 'fa fa-toggle-off',
        styleClass: 'rai-toggle-menu-item',
        command: () => {
          this.toggleRaiModeForApp();
        }
      });

      this.userMenuItems.push({ separator: true });

      this.userMenuItems.push({
        label: this.translate.instant('LOGOUT'),
        icon: 'pi pi-sign-out',
        styleClass: 'logout-menu-item',
        command: () => {
          this.triggerLogout();
        }
      });
    }
  }

  onLogoClick() {
    const isInsideApp = this.routerAppId && this.routerAppId !== 'appId';
    if (isInsideApp) {
      this.handleHamburgerClick();
    } else {
      this.navigateToHome();
    }
  }

  navigateToHome() {
    this.headerService.triggerNavigateHome();
    this.appGlobalService.clearAppInfo();

    this.cleanupListener_AIChatSession();

    this.unblockApp_mergeStatus();
    // Reset fullscreen/sidebar state to prevent stale UI overlay on home page
    if (this.isMenuCollapsed) {
      this.isMenuCollapsed = false;
      this.dispatchMenuCollapsedEvent();
    }
    this.store.dispatch(
      menuActions.toggleSideBar({
        toggleSideBar: {}
      })
    );

    const orgId = this.appGlobalService.get('orgId');
    if (orgId) {
      this.router.navigate(['/home', orgId, 'appId', 'settings', 'appmanagement']);
    }
  }
  /**
   * Attaches a Firestore listener to monitor changes to the logged-in user's ApplicationUser document.
   * If privileges change, notifies the user and triggers logout.
   */
  attachUserDocumentListener() {
    const userSid = this.user?.sid;
    if (!userSid) {
      return;
    }

    if (this.userDocListener) {
      return;
    }

    const queryObject = {
      collectionName: 'ApplicationUser',
      filter: [
        { field: 'sid', operator: '==', value: userSid },
        { field: 'recDeleted', operator: '==', value: false }
      ]
    };

    this.userDocListener = this.fsBaseService.fireService(queryObject).subscribe(
      (res: any[]) => {
        if (res && res.length > 0) {
          const doc = res[0].payload.doc;
          if (doc.metadata.fromCache) {
            return;
          }

          if (res[0].type === 'removed') {
            this.cleanupUserDocListener();
            this.notifyUserAndReload(true);
            return;
          }

          const userData = doc.data();

          if (!this.initialUserSnapshot) {
            this.initialUserSnapshot = { ...userData };
            return;
          }

          // Update the store with the latest user data from Firestore
          this.store.dispatch(setUser({ userData: userData }));
          this.appGlobalService.write('user', userData);

          if (!this.isSystemLevelUser() && this.hasUserPrivilegeChanged(userData)) {
            const removedFromOrg = this.isUserRemovedFromOrg(userData);
            // Cleanup listener to prevent duplicate dialogs from subsequent Firestore events
            this.cleanupUserDocListener();
            this.notifyUserAndReload(removedFromOrg);
          } else {
            // Check if user was removed from any non-current org and update dropdown if not inside an app
            this.updateOrgDropdownIfNeeded(userData);
            // If privileges haven't changed, just update the snapshot for future comparisons
            this.initialUserSnapshot = { ...userData };
          }
        }
      },
      (error) => console.error('Error listening to user document:', error)
    );
  }

  /**
   * Checks if user was removed from the current org.
   */
  isUserRemovedFromOrg(newUserData: any): boolean {
    const orgId = this.appGlobalService.get('orgId');
    return !newUserData.orgIds?.includes(orgId);
  }

  /**
   * Checks if any user privilege fields have changed compared to the initial snapshot.
   */
  hasUserPrivilegeChanged(newUserData: any): boolean {
    const orgId = this.appGlobalService.get('orgId');

    // Removed from current org
    if (!newUserData.orgIds?.includes(orgId)) {
      return true;
    }

    // Role changed for current org
    if (this.initialUserSnapshot.orgInfos?.[orgId] !== newUserData.orgInfos?.[orgId]) {
      return true;
    }

    // Admin flags changed
    if (
      this.initialUserSnapshot.devAdmin !== newUserData.devAdmin ||
      this.initialUserSnapshot.sysAdmin !== newUserData.sysAdmin ||
      this.initialUserSnapshot.devViewer !== newUserData.devViewer
    ) {
      return true;
    }

    // canCreate permission changed
    if (this.initialUserSnapshot.canCreate?.[orgId] !== newUserData.canCreate?.[orgId]) {
      return true;
    }

    return false;
  }

  /**
   * Updates the org dropdown list when user is added to or removed from a non-current org.
   * Only updates if user is not inside any app (to avoid disrupting active work).
   */
  updateOrgDropdownIfNeeded(newUserData: any): void {
    // Only update if user is not inside an app
    if (this.appPage) {
      return;
    }

    // Check if orgIds have changed
    const previousOrgIds = this.initialUserSnapshot?.orgIds || [];
    const currentOrgIds = newUserData?.orgIds || [];

    // Find orgs that were removed (existed before but not now)
    const removedOrgIds = previousOrgIds.filter((orgId: string) => !currentOrgIds.includes(orgId));

    // Find orgs that were added (exist now but not before)
    const addedOrgIds = currentOrgIds.filter((orgId: string) => !previousOrgIds.includes(orgId));

    if (removedOrgIds.length > 0) {
      // Filter out removed orgs from the dropdown lists
      this.orgs = this.orgs.filter((org) => !removedOrgIds.includes(org.sid));
      this.userOrgs = this.userOrgs.filter((org) => !removedOrgIds.includes(org.sid));
    }

    if (addedOrgIds.length > 0) {
      // Refresh org list from API to get full org details for newly added orgs
      this.getOrgList();
    }
  }

  /**
   * Checks if the current user has system-level admin or viewer privileges.
   * @returns true if user is devAdmin, sysAdmin, or devViewer
   */
  isSystemLevelUser(): boolean {
    return this.user?.devAdmin || this.user?.sysAdmin || this.user?.devViewer;
  }

  /**
   * Notifies the user that their privileges have changed.
   * Redirects to home if removed from org, otherwise reloads the page.
   */
  notifyUserAndReload(removedFromOrg = false) {
    if (removedFromOrg) {
      // Show 404-style message when user is removed from org or org is deleted
      this.confirmationDialogService.confirm({
        message: this.translate.instant('ORG_NOT_FOUND_MESSAGE'),
        header: this.translate.instant('ORG_NOT_FOUND_HEADER'),
        acceptLabel: this.translate.instant('OK'),
        rejectVisible: false,
        closable: false,
        accept: () => {
          // Redirect to base domain - app bootstrap will handle landing in correct org
          window.location.href = window.location.origin;
        }
      });
    } else {
      const appId = this.acRoute.snapshot.paramMap.get('appId') || '';
      const isInsideApp = ['', 'appId'].indexOf(appId) === -1;
      // Show generic session update message for privilege changes
      this.confirmationDialogService.confirm({
        message: this.translate.instant(isInsideApp ? 'SHARED_APP_ACCESS_MODIFIED' : 'USER_PRIVILEGES_CHANGED'),
        header: this.translate.instant(isInsideApp ? 'ACCESS_MODIFIED' : 'SESSION_UPDATE_REQUIRED'),
        acceptLabel: this.translate.instant('RELOAD'),
        rejectVisible: false,
        closable: false,
        accept: () => {
          if (appId && isInsideApp) {
            this.redirectToAppList();
          } else {
            // Reload the page to reflect privilege changes
            window.location.reload();
          }
        }
      });
    }
  }

  /**
   * Attaches a Firestore listener to monitor changes to the current app document.
   * Handles:
   * 1. App/Branch/Tag deletion detection (for all users)
   * 2. Shared access changes (for non-admin users)
   * Attaches a Firestore listener to monitor changes to the current app document.
   * Handles:
   * 1. App/Branch/Tag deletion detection (for all users)
   * 2. Shared access changes (for non-admin users)
   */
  attachSharedAccessListener() {
    const appId = this.appGlobalService.get('appId');
    const userEmail = this.user?.email;
    const isAdminUser =
      this.userRole === 'sysAdmin' || this.userRole === 'devAdmin' || this.userRole === 'Organization Admin';

    if (!appId || appId === 'appId') {
      return;
    }

    // Cleanup any existing listener
    this.cleanupSharedAccessListener();
    this.branchDeletionHandled = false;

    const queryObject = {
      collectionName: 'App',
      filter: [
        { field: 'sid', operator: '==', value: appId },
        { field: 'recDeleted', operator: '==', value: false }
      ]
    };

    this.sharedAccessListener = this.fsBaseService.fireService(queryObject).subscribe(
      (res: any[]) => {
        // edge-case, upon moved outside from app, still one-last call coming inside here
        const appId = this.appGlobalService.get('appId');
        if (!appId || appId === 'appId') {
          return;
        }

        this.processSharedAccess({
          userEmail: userEmail,
          isAdminUser: isAdminUser,
          res: res
        });
      },
      (error) => {
        console.error('Error listening to app document changes:', error);
      }
    );
  }

  processSharedAccess(thatResponse: any) {
    let userEmail = thatResponse.userEmail;

    let isAdminUser = thatResponse.isAdminUser;

    let res = thatResponse.res;

    let tuplesMap: any = {
      added: [],
      modified: [],
      removed: []
    };

    if (!res || res.length === 0) {
      return;
    }

    let tuple = res[0].payload.doc.data();

    // Dynamically block or unblock the UI based on the actual Firestore document state

    if (tuple.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS) {
      this.blockApp_mergeStatus();
    } else {
      this.unblockApp_mergeStatus();
    }

    // modified | added
    tuplesMap[res[0].type].push({
      ...tuple,
      _primaryId: tuple.sid
    });

    this.appStateService.updateDataSource({
      name: 'App',
      tuplesMap
    });

    this.appStateService.triggerDataSource({
      name: 'App'
    });

    let boolValue = this.appGlobalService.isBetaAccessPrivilegeConsumableForApp();

    if (!boolValue) {
      if (tuple.createdWithRai === true) {
        this.appGlobalService.updateRecentApp({
          appId: tuple.sid,
          action: 'updateDefaultValueForRAIMode',
          defaultValue: tuple.createdWithRai
        });

        this.appStateService.triggerObservableSource({
          name: 'refreshAppInfo'
        });
      }
    }

    // Handle app/branch/tag deletion
    if (res[0].type === 'removed') {
      this.handleAppOrBranchDeleted();
    } else {
      /*
            NOTE: We have to add entry to watch for AIChatSession's mergeStatus on here, in near future
          */

      // Shared access monitoring - only for non-admin users
      if (isAdminUser || !userEmail) {
        return;
      }

      const appData = res[0].payload.doc.data();
      const currentSharedWith = appData.sharedWith || {};

      // Store initial state on first load
      if (this.initialSharedWith === null) {
        this.initialSharedWith = { ...currentSharedWith };
        return;
      }

      // Check if the current user's shared access was removed
      if (this.hasSharedAccessBeenRemoved(userEmail, currentSharedWith)) {
        this.notifyAccessRemovedAndRedirect();
      }

      if (this.hasSharedAccessBeenModified(userEmail, currentSharedWith)) {
        this.notifyAccessModifiedAndReload(currentSharedWith[userEmail] === OrgRole.PROTOTYPE_VIEWER);
      }

      // Update the stored sharedWith state
      this.initialSharedWith = { ...currentSharedWith };
    }
  }

  blockApp_mergeStatus() {
    this.config.flags.isApp_MergeStatus_InProgress = true;
    this.appSpecificMaintenance = true;
    this.blockedDocument = true;
    this.blockedMessage = 'Merge in progress';
    this.maintenance = true;
  }

  unblockApp_mergeStatus() {
    // Restore the UI, hiding the blocker if status changes or field is deleted

    this.config.flags.isApp_MergeStatus_InProgress = false;
    this.appSpecificMaintenance = false;
    this.blockedDocument = false;
    this.blockedMessage = '';
    this.maintenance = false;
  }

  listenToChatSessionList(thatApp: any) {
    if (this.chatSessionList$ && this.appIdForsessionList === thatApp.sid) {
      return;
    }

    // since AppId is revised, we should switch listener to newAppId
    this.cleanupListener_AIChatSession();

    this.appIdForsessionList = thatApp.sid;

    // if it is added, we can think of following similar to 'messages'(GetHistory by RestAPI(Say, 100) + listener for new items) + Search(Filter)
    this.fsBaseService.runAfterFsLogin(() => {
      // Listen to AIChatConversation

      this.chatSessionList$ = this.fsBaseService
        .fireService({
          collectionName: `AIChatSession_${thatApp.rappitVersion}`,
          filter: [
            { field: 'appId', operator: '==', value: thatApp.sid },
            {
              field: 'recDeleted',
              operator: '==',
              value: false
            }
          ],
          orderby: [
            {
              field: 'modifiedDate',
              dir: 'desc'
            }
          ]
        })
        .subscribe({
          next: (changes: any[]) => {
            let tuplesMap = {
              added: [],
              modified: [],
              removed: []
            };
            if (changes?.length > 0) {
              const loggedInUser = this.appGlobalService.get('userEmail');

              changes.forEach((change) => {
                const doc = change.payload.doc;
                const data = doc.data();

                if (this.appIdForsessionList === data.appId) {
                  // Convert Firebase Timestamps to JS Date objects for consistency with REST API
                  ['modifiedDate'].forEach((field) => {
                    if (data[field]) {
                      data[field] = this.utilService.getJsDateFromTimestamp(data[field]);
                    }
                  });

                  data.isOwner = !!loggedInUser && !!data.userEmail && loggedInUser === data.userEmail;

                  tuplesMap[change.type].push(data);
                }
              });
            }

            this.appStateService.updateDataSource({
              name: 'AIChatSession',
              tuplesMap
            });

            this.appStateService.triggerDataSource({
              name: 'AIChatSession'
            });
          },
          error: (error: any) => {
            let tuplesMap = {
              added: [],
              modified: [],
              removed: []
            };
            this.appStateService.updateDataSource({
              name: 'AIChatSession',
              tuplesMap
            });

            this.appStateService.triggerDataSource({
              name: 'AIChatSession'
            });

            this.utilService.showMessage('error', this.translate.instant('NO_SESSIONS_FOUND'));
          }
        });

      this.subscriptions.push(this.chatSessionList$);
    });
  }

  cleanupListener_AIChatSession() {
    this.chatSessionList$?.unsubscribe();

    this.appStateService.clearDataSource({
      name: 'AIChatSession'
    });

    this.appStateService.clearDataSource({
      name: 'SystemBP_PC'
    });

    this.appStateService.clearDataSource({
      name: 'SystemBP_FD'
    });

    this.appStateService.clearDataSource({
      name: 'SessionBP_PC'
    });

    this.appStateService.clearDataSource({
      name: 'SessionBP_FD'
    });

    this.appIdForsessionList = '';
  }

  /**
   * Handles app or branch/tag deletion detected via Firestore listener.
   * Shows branch/tag-specific message if applicable, otherwise shows generic deletion dialog.
   */
  private handleAppOrBranchDeleted(): void {

    if(!this.appGlobalService.get('appId') || this.appGlobalService.get('appId') === 'appId') {
      return;
    }

    if (this.branchDeletionHandled) {
      return;
    }

    // Skip listener popup when deletion is initiated from current page dropdown flow.
    if (this.appGlobalService.get('branchDeletionInProgress')) {
      this.branchDeletionHandled = true;
      this.cleanupSharedAccessListener();
      return;
    }

    this.branchDeletionHandled = true;
    this.cleanupSharedAccessListener();

    const isDefaultBranch = this.appGlobalService.get('isDefaultBranch') || false;
    const refType = this.appGlobalService.get('appRefType') || '';
    const branchName = this.appGlobalService.get('refsName') || '';
    let message: string;
    if (isDefaultBranch) {
      message = this.translate.instant('APP_DELETED_MESSAGE');
    } else if (refType === 'BRANCH') {
      message = this.translate.instant('BRANCH_DELETED_IN_ANOTHER_TAB', { name: branchName });
    } else {
      message = this.translate.instant('TAG_DELETED_IN_ANOTHER_TAB', { name: branchName });
    }
    const header = this.translate.instant(isDefaultBranch ? 'APP_NOT_FOUND' : 'BRANCH_NOT_FOUND');

    if (!isDefaultBranch) {
      this.notifyAndNavigateToDefaultBranch(message, header);
    } else {
      this.notifyPageNotFoundAndRedirect('APP_LIST', message, header);
    }
  }

  /**
   * Shows a notification dialog for a deleted branch/tag and navigates to the default branch on accept.
   * Falls back to app management if no default branch is found.
   */
  private notifyAndNavigateToDefaultBranch(message: string, header: string): void {
    this.confirmationDialogService.confirm({
      message: message,
      header: header,
      acceptLabel: this.translate.instant('OK'),
      rejectVisible: false,
      closable: false,
      accept: () => {
        this.repoService.navigateToDefaultBranch().then(
          () => {
            // Navigation successful, no further action needed
          },
          (error) => {
            console.error('Error navigating to default branch:', error);
            // If navigation fails (e.g., no default branch), redirect to app list
            this.redirectToAppList();
          }
        );
      }
    });
  }

  /**
   * Checks if the current user's shared access has been removed.
   */
  hasSharedAccessBeenRemoved(userEmail: string, currentSharedWith: Record<string, string>): boolean {
    // If we don't have initial state yet, can't determine if access was removed
    if (!this.initialSharedWith) {
      return false;
    }

    // Check if user was previously in sharedWith and is now removed
    const wasInSharedWith = userEmail in this.initialSharedWith;
    const isInSharedWith = userEmail in currentSharedWith;

    return wasInSharedWith && !isInSharedWith;
  }

  hasSharedAccessBeenModified(userEmail: string, currentSharedWith: Record<string, string>) {
    // If we don't have initial state yet, can't determine if access was modified
    if (!this.initialSharedWith) {
      return false;
    }

    const oldRole = this.initialSharedWith[userEmail];
    const newRole = currentSharedWith[userEmail];

    if (oldRole && newRole && oldRole !== newRole) {
      return true;
    }

    return false;
  }

  notifyPageNotFoundAndRedirect(redirectTo: 'APP_LIST' | 'ORIGIN', message?: string, header?: string) {
    this.confirmationDialogService.confirm({
      message: message,
      header: header,
      acceptLabel: this.translate.instant('OK'),
      rejectVisible: false,
      closable: false,
      accept: () => {
        switch (redirectTo) {
          case 'APP_LIST':
            this.redirectToAppList();
            break;
          case 'ORIGIN':
            this.redirectToOrigin();
            break;
        }
      }
    });
  }

  /**
   * Notifies the user that their shared access has been removed and redirects.
   * Redirects to same org's app list if user still has access, otherwise to base domain.
   */
  notifyAccessRemovedAndRedirect() {
    // Cleanup listeners before showing dialog
    this.cleanupSharedAccessListener();

    this.confirmationDialogService.confirm({
      message: this.translate.instant('SHARED_APP_ACCESS_REMOVED'),
      header: this.translate.instant('ACCESS_REMOVED'),
      acceptLabel: this.translate.instant('OK'),
      rejectVisible: false,
      closable: false,
      accept: () => {
        const orgId = this.appGlobalService.get('orgId');
        const userOrgIds = this.user?.orgIds || [];

        if (orgId && userOrgIds.includes(orgId)) {
          // User still has access to current org, redirect to its app list
          this.redirectToAppList();
        } else {
          // User no longer has access to current org, redirect to root
          this.redirectToOrigin();
        }
      }
    });
  }

  notifyAccessModifiedAndReload(navigateToOrigin = false) {
    // Cleanup listeners before showing dialog
    this.cleanupSharedAccessListener();

    this.confirmationDialogService.confirm({
      message: this.translate.instant('SHARED_APP_ACCESS_MODIFIED'),
      header: this.translate.instant('ACCESS_MODIFIED'),
      acceptLabel: this.translate.instant('OK'),
      rejectVisible: false,
      closable: false,
      accept: () => {
        this.redirectToAppList();
      }
    });
  }

  redirectToAppList() {
    const orgId = this.appGlobalService.get('orgId');
    if (orgId) {
      this.router
        .navigate(['/home', orgId, 'appId', 'settings', 'appmanagement'])
        .catch((error) => console.error(error));
    } else {
      this.document.location.href = '/';
    }
  }

  redirectToOrigin() {
    this.document.location.href = '/';
  }

  private isRepoManagementPopupOpen(): boolean {
    return !!this.appGlobalService.get('isRepoManagementPopupOpen');
  }

  private refreshLifecycleAppList(): void {
    if (!this.currentUrl?.includes('/settings/appmanagement')) {
      return;
    }

    this.store.dispatch(
      getAppsForOrg({
        getAppsApiConstants: ApiConstants.getAppsListData,
        filter: {
          start: 0,
          length: 200
        },
        orgChange: true
      })
    );
  }

  /**
   * Attaches a Firestore listener to monitor changes to all apps in the current organization.
   */
  private allAppsInitialSnapshot: Map<string, any> | null = null;

  attachAllAppsListener() {
    const orgId = this.appGlobalService.get('orgId');
    const userEmail = this.user?.email;
    const isAdminUser = this.userRole === 'sysAdmin' || this.userRole === 'devAdmin' || this.userRole === 'Organization Admin';

    if (!orgId) {
      return;
    }
    // Cleanup any existing all-apps listener
    if (this.allAppsListener) {
      this.allAppsListener.unsubscribe();
      this.allAppsListener = null;
    }
    this.allAppsInitialSnapshot = null;

    const queryObject = {
      collectionName: 'App',
      filter: [
        { field: 'orgId', operator: '==', value: orgId },
        { field: 'recDeleted', operator: '==', value: false }
      ]
    };

    this.allAppsListener = this.fsService.fireService(queryObject).subscribe(
      (res: any[]) => {
        if (!res || res.length === 0) {
          return;
        }

        // Build initial snapshot on first load
        if (this.allAppsInitialSnapshot === null) {
          this.buildAllAppsInitialSnapshot(res);
          return;
        }

        // Process changes after initial snapshot
        this.processAllAppsChanges(res, isAdminUser, userEmail);
      },
      (error) => {
        console.error('Error listening to all apps:', error);
      }
    );
  }

  /** Builds the initial snapshot of all apps keyed by their sid. */
  private buildAllAppsInitialSnapshot(res: any[]): void {
    this.allAppsInitialSnapshot = new Map();
    for (const change of res) {
      const appData = change?.payload?.doc?.data?.();
      if (appData?.sid) {
        this.allAppsInitialSnapshot.set(appData.sid, appData);
      }
    }
  }

  /** Processes app changes emitted after the initial snapshot has been built. */
  private processAllAppsChanges(res: any[], isAdminUser: boolean, userEmail: string): void {
    for (const change of res) {
      const doc = change?.payload?.doc;
      if (!doc) {
        continue;
      }
      const appData = doc.data();
      const appSid = appData?.sid;
      if (!appSid) {
        continue;
      }

      if (change?.type === 'removed') {
        if (this.handleRemovedApp(appSid)) {
          return;
        }
      } else if (change?.type === 'modified') {
        if (this.handleModifiedApp(appSid, appData, isAdminUser, userEmail)) {
          return;
        }
      }
    }
  }

  /** Handles a removed app change. Returns true if a notification/refresh was triggered. */
  private handleRemovedApp(appSid: string): boolean {
    if (!this.allAppsInitialSnapshot!.has(appSid)) {
      return false;
    }
    const removedApp = this.allAppsInitialSnapshot!.get(appSid);
    this.allAppsInitialSnapshot!.delete(appSid);
    if (!this.isRepoManagementPopupOpen()) {
      this.refreshLifecycleAppList();
    }
    return true;
  }

  /** Handles a modified app change. Returns true if a shared-access notification was triggered. */
  private handleModifiedApp(appSid: string, appData: any, isAdminUser: boolean, userEmail: string): boolean {
    if (!isAdminUser && userEmail && this.notifySharedAccessChange(appSid, appData, userEmail)) {
      return true;
    }
    this.allAppsInitialSnapshot!.set(appSid, appData);
    return false;
  }

  /** Notifies when the current user's shared access to an app was removed or modified. Returns true if notified. */
  private notifySharedAccessChange(appSid: string, appData: any, userEmail: string): boolean {
    const previousApp = this.allAppsInitialSnapshot!.get(appSid);
    const previousSharedWith = previousApp?.sharedWith || {};
    const currentSharedWith = appData.sharedWith || {};
    const wasShared = userEmail in previousSharedWith;
    const isShared = userEmail in currentSharedWith;

    const accessRemoved = wasShared && !isShared;
    const accessModified = wasShared && isShared && previousSharedWith[userEmail] !== currentSharedWith[userEmail];

    if (!accessRemoved && !accessModified) {
      return false;
    }

    this.allAppsInitialSnapshot!.set(appSid, appData);
    const messageKey = accessRemoved ? 'SHARED_APP_ACCESS_REMOVED_FROM_APP' : 'SHARED_APP_ACCESS_MODIFIED_FOR_APP';
    this.notifyAppListChanged(
      this.translate.instant(messageKey, { name: appData.name || appSid }),
      this.translate.instant('ACCESS_MODIFIED')
    );
    return true;
  }

  /**
   * Shows a popup notification when the app list changes on the lifecycle page.
   * On accept, closes the repo popup and refreshes the lifecycle app list.
   */
  private notifyAppListChanged(message: string, header: string) {
    this.confirmationDialogService.confirm({
      message,
      header,
      acceptLabel: this.translate.instant('OK'),
      rejectVisible: false,
      closable: false,
      accept: () => {
        if(header === this.translate.instant('ACCESS_MODIFIED')) {
           this.appGlobalService.requestCloseRepoManagementPopup();
        }
      }
    });
  }

}

